var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1267",
    "data-name": "Group 1267",
    xmlns: "http://www.w3.org/2000/svg",
    width: 4651,
    height: 4717.219,
    viewBox: "0 0 4651 4717.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071",
    transform: "translate(51.102 2685.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3516",
    "data-name": "Path 3516",
    d: "M492.862,1143.821h-3.7l-50.51-4.928c-11.088-1.232-19.711-6.16-27.1-14.784-6.16-8.624-9.856-18.479-8.624-29.567l3.7-36.959c-19.711-4.928-38.191-12.32-56.67-19.711l-24.639,33.263c-6.16,8.624-14.783,14.784-25.871,16.015a42.842,42.842,0,0,1-29.567-7.392l-43.119-30.8c-17.247-12.319-20.943-36.958-8.624-55.438l22.175-30.8a376.115,376.115,0,0,1-39.423-46.814L162.7,934.388c-9.856,3.7-19.711,4.928-29.567,1.232a36.739,36.739,0,0,1-20.943-19.711L88.78,864.166c-8.624-18.479,0-41.887,18.479-50.511l35.727-16.015A475.02,475.02,0,0,1,131.9,737.275l-41.887-4.928c-9.856-1.232-19.711-6.16-25.871-13.552s-9.856-18.479-8.624-28.335l6.16-55.438c1.232-9.856,6.16-19.711,13.552-25.871,8.624-6.16,18.479-9.856,28.335-8.624l38.191,3.7c4.928-19.711,12.32-39.423,19.711-57.9L128.2,521.682c-17.247-12.32-20.943-36.959-8.624-54.206l32.031-44.351c6.16-8.624,14.784-13.552,25.871-16.015,9.856-1.232,20.943,1.232,28.335,7.392l30.8,22.175c13.552-14.784,29.567-27.1,45.582-39.423L263.718,356.6c-8.624-18.479,0-40.655,18.479-48.046l52.974-24.639c8.624-3.7,18.479-3.7,28.335-1.232,8.624,3.7,16.016,9.856,19.711,19.711l16.015,36.959c19.711-4.928,39.423-9.855,60.366-11.087l3.7-45.583c1.232-9.856,4.928-17.247,12.32-23.407s16.016-8.624,25.871-7.392l61.6,6.16c9.856,1.232,17.247,4.928,23.407,12.32s8.624,16.015,7.392,25.871l-4.928,41.887c18.479,4.928,38.191,11.087,57.9,19.711l25.871-36.959c4.928-7.392,13.552-12.32,22.175-13.552a38.73,38.73,0,0,1,25.871,6.16l50.51,36.959c16.016,11.088,18.479,33.263,7.392,48.046l-24.639,34.495a453.965,453.965,0,0,1,39.423,45.583l39.423-17.247c8.624-3.7,18.479-4.928,28.335-1.232A36.739,36.739,0,0,1,882.161,479.8l23.407,52.974c8.624,18.479,0,40.655-18.479,49.279L850.13,598.063c4.928,19.711,9.856,39.423,11.088,60.366l44.35,4.928c19.711,2.464,34.495,19.711,32.031,39.423l-6.16,60.366a38.062,38.062,0,0,1-13.552,24.639,33.788,33.788,0,0,1-25.871,7.392l-40.655-3.7c-4.928,19.711-12.32,39.423-19.711,57.9l32.031,23.407a41.326,41.326,0,0,1,8.624,57.9l-29.567,40.654a38.9,38.9,0,0,1-27.1,16.015c-11.088,1.232-22.175-1.232-30.8-7.392L756.5,959.027c-14.783,14.784-29.567,28.335-45.582,39.423l17.247,40.655c8.624,18.479,0,40.654-18.479,49.278l-52.974,23.407c-8.624,3.7-18.479,4.928-28.335,1.232s-16.016-11.088-20.943-19.712l-16.015-36.959a498.686,498.686,0,0,1-59.134,11.088l-3.7,40.654C531.053,1129.037,513.805,1143.821,492.862,1143.821Zm-146.6-118.268,3.7,1.232a271.7,271.7,0,0,0,62.83,22.175l3.7,1.232-4.928,44.351a28,28,0,0,0,6.16,22.175c4.928,6.16,12.32,9.855,20.943,11.087l50.51,4.928c17.247,1.232,32.031-11.087,33.263-27.1l4.928-41.886a5.82,5.82,0,0,1,6.16-6.16c20.943-2.464,41.887-6.16,61.6-12.32,3.7-1.232,6.16,0,8.624,3.7l17.247,38.191c2.464,7.392,8.624,12.32,14.784,14.784,7.392,2.464,14.784,2.464,20.943,0l52.974-23.407c13.552-6.16,19.711-22.175,13.552-36.959l-18.479-41.886c-1.232-2.464,0-6.16,2.464-8.624a308.275,308.275,0,0,0,48.046-41.886,7.588,7.588,0,0,1,8.624-1.232l30.8,22.175c7.392,4.928,14.783,7.392,23.407,6.16a33.287,33.287,0,0,0,20.943-12.32L868.609,923.3c9.856-14.784,7.392-34.495-7.392-44.351l-38.191-28.335,1.232-3.7c9.856-19.711,17.247-41.887,22.175-62.83l1.232-3.7,49.278,4.928c7.392,1.232,13.552-1.232,19.711-6.16,4.928-4.928,8.624-11.088,9.856-17.247l6.16-60.366c1.232-14.784-8.624-27.1-23.407-29.567l-51.742-4.928v-3.7c-2.464-23.407-6.16-45.582-12.32-66.526l-1.232-3.7,44.35-19.711c13.552-6.16,19.711-22.175,13.552-36.959l-23.407-52.974c-2.464-7.392-8.624-12.319-16.016-14.784s-14.783-2.464-20.943,1.232l-46.814,20.943-2.464-3.7a283.128,283.128,0,0,0-43.119-50.511l-2.464-2.464,29.567-40.655c8.624-11.087,6.16-27.1-6.16-35.727l-50.51-36.959c-4.928-3.7-12.32-6.16-18.479-4.928a27.386,27.386,0,0,0-16.016,9.855l-30.8,43.119-3.7-1.232a319.213,319.213,0,0,0-62.83-22.175l-3.7-1.232,4.928-50.51c1.232-7.392-1.232-13.552-6.16-18.479s-9.856-8.624-17.247-9.856l-61.6-6.16c-6.16-1.232-13.551,1.232-18.479,6.16s-8.624,11.087-9.856,17.247l-4.928,52.974h-3.7c-22.175,2.464-44.35,6.16-66.526,12.32l-3.7,1.232-19.711-44.351a28.855,28.855,0,0,0-14.783-14.783c-6.16-2.464-13.552-2.464-20.943,0l-52.974,24.639a27.066,27.066,0,0,0-13.552,35.727l18.479,41.887c1.232,2.464,0,6.16-2.464,8.624a308.259,308.259,0,0,0-48.046,41.887,7.588,7.588,0,0,1-8.624,1.232L202.12,420.662c-6.16-4.928-13.552-6.16-22.175-4.928a28.772,28.772,0,0,0-19.711,12.319L128.2,472.4c-9.856,13.552-6.16,32.031,6.16,41.887l39.423,29.567-1.232,3.7a319.209,319.209,0,0,0-22.175,62.83l-1.232,3.7-45.582-4.928c-7.392-1.232-14.783,1.232-20.943,6.16a32.01,32.01,0,0,0-11.088,19.711l-6.16,55.438c-1.232,7.392,1.232,14.784,6.16,20.943a32.011,32.011,0,0,0,19.711,11.088l49.278,4.928v3.7c2.464,22.175,6.16,44.351,12.32,65.294l1.232,3.7-43.119,19.711c-14.784,6.16-20.943,23.407-14.784,38.191l23.407,51.742c3.7,7.392,8.624,12.32,16.015,14.784S150.378,927,157.769,923.3l45.582-20.943,2.464,3.7c13.552,19.711,28.335,35.727,44.351,50.51l2.464,2.464-27.1,38.191c-9.856,13.552-6.16,32.031,6.16,41.887l43.119,30.8c6.16,4.928,14.783,6.16,22.175,4.928s14.784-6.16,19.711-12.32ZM500.254,854.311c-4.928,0-11.088,0-16.016-1.232-9.856-1.232-19.711-3.7-29.567-6.16-59.134-18.479-102.253-72.685-108.412-134.283a155.45,155.45,0,0,1,56.67-135.515c40.655-32.031,93.629-43.119,142.907-27.1C604.97,568.5,648.089,622.7,654.249,684.3a155.45,155.45,0,0,1-56.67,135.516C568.012,843.223,534.749,854.311,500.254,854.311Zm0-300.6a144.3,144.3,0,0,0-91.165,32.031c-38.191,30.8-57.9,78.845-54.206,126.892,4.928,57.9,45.582,108.412,101.021,125.66a191.389,191.389,0,0,0,28.335,6.16c4.928,0,9.856,1.232,14.783,1.232,33.263,0,64.062-11.088,91.165-32.031,38.191-30.8,57.9-78.845,54.206-126.892-4.928-57.9-45.582-108.412-101.021-125.66C528.589,554.945,513.805,553.713,500.254,553.713Z",
    transform: "translate(-55.281 -251.575)",
    fill: "#6d72a0"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    transform: "translate(89.963 670.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073",
    transform: "translate(496.07 454.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3517",
    "data-name": "Path 3517",
    d: "M149.187,124.9l11.088,1.232c-46.815,342.485-98.557,731.783,36.959,1079.2,94.861,241.464,272.263,438.577,444.737,629.531,70.222,78.845,144.139,158.923,210.665,242.7,172.474,215.593,300.6,457.057,372.052,698.521,35.727,123.2,57.9,242.7,64.062,359.732h-12.32c-18.479-349.876-168.778-721.928-432.417-1052.093-66.526-82.541-139.211-163.85-210.665-242.7-172.474-192.186-352.34-390.531-447.2-633.227C49.4,859.147,102.373,469.848,149.187,124.9Z",
    transform: "translate(-98.702 -124.9)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(502.887 445.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3518",
    "data-name": "Path 3518",
    d: "M219.305,798.186c48.046-34.5,99.789-72.686,114.572-129.356,9.856-39.423,0-82.541,16.016-119.5,17.247-40.655,59.134-65.294,83.773-102.252,32.031-48.046,32.031-112.108,61.6-162.619,24.639-43.119,71.454-76.381,75.15-125.66,1.232-8.624,0-18.479-6.16-25.871-13.552-16.016-39.423-7.392-56.67,4.928C443.522,182.207,395.476,247.5,374.532,321.418c-12.32,40.655-17.247,85.005-44.351,118.268-14.783,17.247-33.263,29.567-50.51,44.351-30.8,28.335-54.206,65.294-64.062,105.949-8.624,33.263-7.392,68.99-24.639,99.789C161.4,741.516,92.414,771.083,99.806,843.769,108.429,946.021,189.738,819.129,219.305,798.186Z",
    transform: "translate(-99.255 -124.191)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(588.442 863.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3519",
    "data-name": "Path 3519",
    d: "M122.215,876.437A230.461,230.461,0,0,1,106.2,827.158c18.479-39.422,61.6-65.294,82.541-103.484,17.248-29.567,17.248-66.526,24.639-99.789a206.309,206.309,0,0,1,64.062-105.949c17.247-14.783,35.727-27.1,50.51-44.351,27.1-32.031,32.031-77.613,44.35-118.268,22.175-73.918,70.222-140.443,133.052-183.562,17.247-12.32,43.119-20.943,56.67-4.928,6.16,7.392,7.392,17.247,6.16,25.871-3.7,49.278-50.51,82.541-75.15,125.66-29.567,50.51-29.567,114.572-61.6,162.618-24.639,36.959-66.526,61.6-83.773,102.253-14.783,36.959-6.16,81.309-16.016,119.5-14.783,56.67-66.526,94.861-114.572,129.356-16.016,12.32-50.51,57.9-77.614,76.381C134.535,899.844,128.375,887.524,122.215,876.437Z",
    transform: "translate(-106.2 -158.091)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079",
    transform: "translate(716.015 1119.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3520",
    "data-name": "Path 3520",
    d: "M236.606,852.886c48.046-34.495,99.789-72.685,114.572-129.356,9.856-39.423,0-82.541,16.016-119.5,17.247-40.655,59.134-65.294,83.773-102.253C483,453.732,483,389.67,512.565,339.159c24.639-43.119,71.454-76.381,75.15-125.66,1.232-8.624,0-18.479-6.16-25.871-13.552-16.015-39.423-7.392-56.67,4.928C460.822,236.907,412.776,302.2,391.833,376.118c-12.32,40.655-17.247,85.005-44.351,118.268-14.783,17.247-33.263,29.567-50.51,44.351-30.8,28.335-54.206,65.294-64.062,105.949-8.624,33.263-7.392,68.99-24.639,99.789-29.567,51.742-98.557,81.309-91.165,153.995C125.729,1000.721,208.271,873.829,236.606,852.886Z",
    transform: "translate(-116.555 -178.891)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081",
    transform: "translate(922.266 1266.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3521",
    "data-name": "Path 3521",
    d: "M250.37,900.98c43.119-40.655,89.933-85.005,97.325-142.907,4.928-40.655-9.856-82.541,1.232-120.732,11.088-43.119,50.51-72.686,70.222-112.108,25.871-51.742,18.479-115.8,40.655-168.778,19.711-45.582,61.6-85.005,59.134-134.283,0-8.624-2.464-18.479-9.856-24.639-14.783-14.783-40.655-2.464-55.438,12.319-57.9,51.742-97.325,123.2-109.644,199.577-7.392,41.887-6.16,87.469-29.567,123.2-12.32,18.48-29.567,33.263-44.351,49.278a211.856,211.856,0,0,0-50.51,113.34c-3.7,34.495,1.232,70.222-12.32,101.021-22.175,55.438-87.469,93.629-71.454,163.85C157.973,1061.135,224.5,925.619,250.37,900.98Z",
    transform: "translate(-133.297 -190.858)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083",
    transform: "translate(1144.38 1522.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3522",
    "data-name": "Path 3522",
    d: "M264.342,945.516c38.191-45.583,80.077-94.861,80.077-152.763,0-40.655-18.479-80.077-13.552-120.732,6.16-43.119,41.887-77.613,56.67-119.5,19.711-54.206,4.928-117.036,20.943-172.474C422.032,332,458.991,288.882,451.6,239.6c-1.232-8.624-4.928-18.479-12.319-23.407-17.247-12.319-40.655,2.464-54.206,18.479a342.326,342.326,0,0,0-86.237,210.665c-2.464,41.887,3.7,87.469-14.784,125.66-9.856,19.711-25.871,35.727-38.191,54.206C222.455,659.7,208.9,701.588,208.9,743.475c0,34.5,8.624,68.99,0,102.253-16.015,57.9-76.381,102.252-51.742,171.242C191.656,1115.526,240.934,972.619,264.342,945.516Z",
    transform: "translate(-151.326 -211.629)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085",
    transform: "translate(1353.252 1731.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3523",
    "data-name": "Path 3523",
    d: "M296.641,341.235c-34.495,48.046-70.222,101.021-66.526,160.155,3.7,40.655,25.871,78.846,23.407,118.268-2.464,44.351-34.495,81.309-45.583,123.2-14.783,56.67,6.16,117.036-6.16,173.706-9.856,48.046-43.119,94.861-30.8,142.907,2.464,8.624,6.16,17.247,13.551,22.175,18.479,11.088,39.423-6.16,52.975-23.407,45.582-61.6,70.221-140.443,67.758-216.825-1.232-41.887-11.088-86.237,3.7-125.66,7.392-20.944,22.175-38.191,33.263-57.9C363.167,622.121,371.791,579,368.1,537.116c-3.7-34.495-14.783-67.758-8.624-102.252C370.559,375.729,426,325.219,396.43,259.925,354.543,165.065,317.584,312.9,296.641,341.235Z",
    transform: "translate(-168.281 -228.553)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087",
    transform: "translate(1487.535 2010.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3524",
    "data-name": "Path 3524",
    d: "M307.541,364.081C273.046,412.128,237.32,465.1,241.015,524.236c3.7,40.654,25.871,78.845,23.407,118.268-2.464,44.35-34.495,81.309-45.583,123.2-14.783,56.67,6.16,117.036-6.16,173.706-9.856,48.047-43.119,94.861-30.8,142.907,2.464,8.624,6.16,17.247,13.551,22.175,18.479,11.087,39.423-6.16,52.974-23.407,45.583-61.6,70.222-140.443,67.758-216.825-1.232-41.886-11.088-86.237,3.7-125.66,7.392-20.943,22.175-38.191,33.263-57.9,20.943-35.727,29.567-78.846,25.871-120.732-3.7-34.495-14.783-67.758-8.624-102.252,11.087-59.134,66.526-109.644,36.959-174.938C365.443,187.911,328.484,334.514,307.541,364.081Z",
    transform: "translate(-179.181 -251.241)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089",
    transform: "translate(536.224 2401.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3525",
    "data-name": "Path 3525",
    d: "M233.025,303.359c56.67-16.015,119.5-32.031,172.474-8.624,36.959,16.015,65.294,50.51,103.484,62.83,41.887,12.32,87.469-4.928,131.82-1.232,57.9,4.928,108.412,44.351,165.082,52.974,49.278,7.392,104.717-8.624,145.371,19.711,7.392,4.928,14.783,12.32,16.015,20.943,4.928,20.943-19.711,35.727-39.422,41.887-73.918,22.175-155.227,18.479-226.68-9.855-39.423-16.015-77.613-39.423-120.732-38.191-22.175,0-43.119,7.392-65.294,12.32-40.655,7.392-85.005,1.232-121.964-16.015-30.8-14.784-59.134-36.959-93.629-43.119-59.134-9.856-125.66,25.871-177.4-24.639C48.231,298.431,198.53,313.214,233.025,303.359Z",
    transform: "translate(-101.961 -282.943)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(693.915 2661.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3526",
    "data-name": "Path 3526",
    d: "M245.825,324.459c56.67-16.015,119.5-32.031,172.474-8.624,36.959,16.015,65.294,50.511,103.484,62.83,41.887,12.32,87.469-4.928,131.82-1.232,57.9,4.928,108.413,44.351,165.082,52.974,49.278,7.392,104.717-8.624,145.371,19.711,7.392,4.928,14.783,12.32,16.016,20.943,4.928,20.944-19.711,35.727-39.423,41.887-73.917,22.175-155.227,18.479-226.68-9.855-39.423-16.015-77.613-39.423-120.732-38.191-22.175,0-43.119,7.392-65.294,12.32-40.655,7.392-85.005,1.232-121.964-16.015-30.8-14.784-59.134-36.959-93.629-43.119-59.134-9.855-125.66,25.871-177.4-24.639C61.031,318.3,211.33,333.082,245.825,324.459Z",
    transform: "translate(-114.761 -304.043)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093",
    transform: "translate(1603.14 2327.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3527",
    "data-name": "Path 3527",
    d: "M405.825,378.833C366.4,421.952,322.051,470,319.588,529.132c-2.464,40.655,16.015,81.309,8.624,120.732-8.624,43.119-44.351,76.381-61.6,117.036-22.175,54.206-9.856,117.036-28.335,171.242-16.015,46.814-54.206,88.7-49.278,137.98,1.232,8.624,3.7,18.479,11.087,24.639,16.015,13.552,40.655-1.232,55.438-16.015,54.206-55.438,87.469-129.356,94.861-206.969,3.7-41.887,0-87.469,20.943-124.428,11.087-19.711,27.1-35.727,40.655-52.974,24.639-33.263,39.423-75.15,41.887-115.8,1.232-34.495-6.16-68.99,4.928-102.252,18.479-56.67,80.077-99.789,59.134-168.778C485.9,211.287,430.464,352.962,405.825,378.833Z",
    transform: "translate(-188.565 -276.928)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(830.703 2871.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3528",
    "data-name": "Path 3528",
    d: "M259.351,329.212c57.9-8.624,121.964-17.247,172.474,13.551,34.495,20.944,57.9,59.134,94.861,75.15,40.655,17.247,87.469,6.16,130.588,16.015,56.67,12.319,101.021,57.9,157.691,73.917,48.046,13.552,104.716,4.928,141.675,38.191,7.392,6.16,12.319,13.552,13.551,23.407,1.232,20.943-23.407,33.263-44.351,35.726-76.381,12.32-156.459-1.232-224.216-39.423-36.959-20.943-71.454-49.278-114.572-54.206-22.175-2.464-44.351,2.465-66.526,3.7a215.329,215.329,0,0,1-119.5-32.031c-28.335-18.479-54.206-44.35-86.237-54.206-56.67-17.247-128.124,9.856-172.474-46.814C77.021,300.877,224.856,334.14,259.351,329.212Z",
    transform: "translate(-125.865 -321.145)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097",
    transform: "translate(1638.659 2722.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3529",
    "data-name": "Path 3529",
    d: "M440.947,746.931c-28.335,32.031-34.495,76.382-48.046,117.036-23.407,73.918-73.918,137.98-137.979,181.1a134.357,134.357,0,0,1-13.552,7.392H200.715l-3.7-3.7c-6.16-7.391-6.16-17.247-4.928-25.871,4.928-49.278,51.742-81.309,77.613-124.428,30.8-49.278,32.031-113.34,65.294-161.387,25.871-35.727,67.758-59.134,86.237-99.789,16.015-36.958,7.392-80.077,18.479-119.5,16.015-56.67,68.99-93.629,117.036-126.891,29.567-19.712,114.572-145.371,121.964-40.655,4.928,72.685-65.294,99.789-94.861,151.531-17.247,29.567-18.479,65.294-27.1,98.557a210.353,210.353,0,0,1-66.526,104.716C474.21,718.6,454.5,729.685,440.947,746.931Z",
    transform: "translate(-191.448 -309.057)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099",
    transform: "translate(904.013 3141.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3530",
    "data-name": "Path 3530",
    d: "M265.909,351.484c59.134-4.928,123.2-8.624,171.242,24.639,33.263,23.407,54.206,62.83,89.933,81.31,39.422,20.943,87.469,12.319,129.356,23.407,55.438,16.015,97.325,65.293,152.763,83.773,46.815,16.015,103.485,12.32,139.211,46.814,6.16,6.16,12.32,14.783,12.32,23.407,0,16.015-13.552,24.639-29.567,29.567H821.522a334.066,334.066,0,0,1-129.356-50.511c-35.727-23.407-68.99-54.206-110.876-61.6-22.175-3.7-44.351-1.232-66.526-1.232-41.886-1.232-83.773-14.783-117.036-39.423-27.1-19.711-50.51-48.046-82.541-59.134-55.438-20.944-128.124,1.232-168.778-57.9C86.043,310.829,230.182,355.18,265.909,351.484Z",
    transform: "translate(-131.815 -343.012)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101",
    transform: "translate(174.274 635.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3531",
    "data-name": "Path 3531",
    d: "M329.058,854.379c-41.887-40.655-88.7-86.237-94.861-144.139-4.928-40.655,11.088-81.309,1.232-120.732-11.088-43.119-49.278-72.685-67.758-113.34-25.871-51.742-16.016-115.8-38.191-170.01C111,260.575,69.115,219.92,72.811,170.642c0-8.624,2.464-18.479,9.856-24.639,16.016-14.783,40.655-1.232,55.438,12.32,56.67,51.742,94.861,124.428,107.18,200.809,6.16,41.887,4.928,87.469,28.335,123.2,12.32,18.479,29.567,33.263,43.119,50.51,27.1,32.031,44.351,72.686,48.046,113.34,3.7,34.495-1.232,70.222,11.088,102.253,20.943,55.438,86.237,94.861,68.99,165.083C418.991,1017,354.929,880.25,329.058,854.379Z",
    transform: "translate(-72.581 -139.579)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103",
    transform: "translate(0 1227.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3532",
    "data-name": "Path 3532",
    d: "M641.949,680.678c-57.9-12.319-120.732-27.1-156.459-73.917-24.639-32.031-33.263-75.15-62.83-103.484-32.031-30.8-80.077-36.959-117.036-60.366-49.278-30.8-73.918-89.933-121.964-124.428-39.423-29.567-96.093-41.886-119.5-85-3.7-7.392-7.392-17.247-4.928-25.871,6.16-19.711,33.263-22.175,54.206-18.479,76.381,14.784,146.6,56.67,195.881,115.8,27.1,32.031,50.51,71.454,88.7,89.933,19.711,9.856,41.887,13.552,62.83,20.943C500.274,429.359,536,454,561.872,487.261c20.943,27.1,34.495,60.366,62.83,81.309C672.748,604.3,747.9,604.3,770.073,673.287,802.1,773.075,676.444,689.3,641.949,680.678Z",
    transform: "translate(-58.435 -187.683)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105",
    transform: "translate(229.751 1732.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3533",
    "data-name": "Path 3533",
    d: "M724.054,634.152c-59.134-3.7-123.2-8.624-166.314-49.278-29.567-28.335-44.351-68.99-77.614-92.4C444.4,466.605,395.121,467.838,355.7,450.59c-52.974-23.407-87.469-77.613-139.211-104.716-44.351-23.407-101.021-27.1-130.588-66.526-4.928-7.392-9.856-16.015-8.624-24.639,2.464-20.943,29.567-27.1,50.51-25.871,77.613,2.464,152.763,33.263,211.9,83.773,32.031,28.335,60.366,62.83,101.021,76.381,20.943,7.392,44.35,7.392,65.294,9.856,40.655,6.16,80.077,25.871,110.876,55.438,24.639,23.407,44.351,54.206,73.918,70.221,52.974,28.335,126.892,16.016,160.155,81.309C896.528,699.446,759.781,636.616,724.054,634.152Z",
    transform: "translate(-77.084 -228.688)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107",
    transform: "translate(342.911 2140.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3534",
    "data-name": "Path 3534",
    d: "M812.264,495.913c-57.9,12.32-120.732,25.871-172.474-1.232-35.727-18.48-61.6-54.206-99.789-67.758-41.887-14.784-87.469,0-131.819-4.928-57.9-7.392-105.948-50.51-162.619-61.6-48.046-9.856-104.717,2.464-144.139-27.1-7.392-4.928-13.551-12.319-14.783-22.175-3.7-20.943,20.943-34.495,41.887-39.423,75.15-18.479,156.459-11.087,226.68,22.175,38.191,18.479,75.149,43.119,118.268,45.583,22.175,1.232,44.35-6.16,66.526-8.624,41.887-4.928,85.005,2.464,121.964,22.175,30.8,16.015,56.67,40.654,91.165,48.046,57.9,12.319,126.892-19.711,176.17,33.263C995.826,511.928,846.759,488.521,812.264,495.913Z",
    transform: "translate(-86.27 -261.796)",
    fill: "#4e6fd8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109",
    transform: "translate(471.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3535",
    "data-name": "Path 3535",
    d: "M203.428,835.489c33.263-49.278,68.99-102.253,62.83-161.387-3.7-40.655-28.335-77.613-25.871-118.268,1.232-44.351,32.031-81.309,43.119-124.428,13.552-56.67-8.624-117.036,2.464-173.706,8.624-49.278,40.655-96.093,27.1-144.139-2.464-8.624-7.392-17.247-14.784-22.175-18.479-11.088-39.423,7.392-51.742,24.639-44.351,62.83-66.526,141.675-61.6,219.289,2.464,41.887,13.552,86.237-1.232,126.892-7.392,20.943-20.943,39.423-32.031,57.9-19.711,36.959-28.335,80.077-23.407,120.732,3.7,34.495,16.016,67.758,11.088,102.253C129.511,802.226,75.3,853.968,106.1,919.262,150.454,1012.891,183.717,865.056,203.428,835.489Z",
    transform: "translate(-96.74 -88.027)",
    fill: "#4e6fd8"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125",
    transform: "translate(0 2702.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3536",
    "data-name": "Path 3536",
    d: "M1042.925,274.4,789.141,1314.173H109.1L366.579,347.086A97.273,97.273,0,0,1,460.208,274.4Z",
    transform: "translate(605.031 -10.761)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111",
    transform: "translate(112.7 1369.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3537",
    "data-name": "Path 3537",
    d: "M205.888,364.2h24.639L83.924,881.623a11.834,11.834,0,0,1-11.088,8.624h-3.7c-6.16-1.232-9.856-8.624-8.624-14.783Z",
    transform: "translate(-60.281 -364.2)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112",
    transform: "translate(619.035 1369.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3538",
    "data-name": "Path 3538",
    d: "M229.741,364.2H254.38L123.792,887.782a11.834,11.834,0,0,1-11.088,8.624h-2.464c-6.16-1.232-9.856-7.392-8.624-14.783Z",
    transform: "translate(-101.381 -364.2)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3539",
    "data-name": "Path 3539",
    d: "M58.5,339.8l753.959,6.16L701.582,705.692,256.845,756.2c-72.686,8.624-140.443-35.727-150.3-99.789Z",
    transform: "translate(32.26 729.54)",
    fill: "#8b5e5e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113",
    transform: "translate(1418.812 1351.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3540",
    "data-name": "Path 3540",
    d: "M190.939,362.7V892.442a12.32,12.32,0,0,1-24.639,0V362.7Z",
    transform: "translate(-166.3 -362.7)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3541",
    "data-name": "Path 3541",
    d: "M606.482,356.3c-12.32,46.814-24.639,89.933-34.495,124.428-19.711,65.293,56.67,107.18-13.552,107.18-200.809,0-356.036,0-475.536,1.232V356.3H606.482Z",
    transform: "translate(308.458 916.313)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3542",
    "data-name": "Path 3542",
    d: "M65.1,356.3H286.853V590.372c-103.485,0-49.278,0-97.325-1.232Z",
    transform: "translate(106.97 916.313)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3543",
    "data-name": "Path 3543",
    d: "M298.494,1287.071c45.582,4.927,145.371,9.855,209.433,13.552,20.943,0,40.655,4.928,59.134,4.928,97.325-2.464,222.985,38.191,253.784-70.222,32.031-112.109,146.6-787.222,177.4-896.866,11.087-38.191,27.1-64.062,66.526-64.062h25.871c27.1,0,45.583,23.407,43.119,50.51C1121.443,455.5,1008.1,1264.9,973.608,1409.034c-16.016,65.294-62.83,107.181-120.732,107.181H284.943c-24.639,0-137.979,6.16-161.386-11.088-64.062-46.814,56.67-99.789,76.381-155.227C220.881,1294.463,240.592,1279.678,298.494,1287.071Z",
    transform: "translate(558.544 -10.762)",
    fill: "#8b5e5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3544",
    "data-name": "Path 3544",
    d: "M142.16,348.5c-1.232,1.232-3.7,1.232-6.16,2.464A51.748,51.748,0,0,0,142.16,348.5Z",
    transform: "translate(909.528 828.02)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114",
    transform: "translate(855.486 1073.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3545",
    "data-name": "Path 3545",
    d: "M127.054,635.77c3.7,0,6.16-2.464,6.16-4.927L168.941,463.3c13.552-64.062,65.294-108.412,124.428-108.412H704.843a7.392,7.392,0,0,0,0-14.784H294.6c-66.526,0-123.2,49.278-137.979,119.5L120.894,627.147c-1.232,3.7,1.232,7.391,4.928,8.624Z",
    transform: "translate(-120.574 -340.1)",
    fill: "#282f39"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3546",
    "data-name": "Path 3546",
    d: "M265.089,521.014c24.639,118.268,187.258,256.247,110.876,256.247-215.593,0-294.438-135.515-319.077-253.783S90.151,339.916,165.3,339.916C242.914,338.684,241.682,402.746,265.089,521.014Z",
    transform: "translate(-51.133 730.656)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3547",
    "data-name": "Path 3547",
    d: "M140.86,349.7c-1.232,1.232-3.7,1.232-6.16,2.464C139.628,350.931,140.86,349.7,140.86,349.7Z",
    transform: "translate(894.813 841.603)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3548",
    "data-name": "Path 3548",
    d: "M647.076,1039.627c3.7-3.7,7.392-11.087,9.856-19.712a165.844,165.844,0,0,0,3.7-77.613c-41.887-213.129,13.552-289.51,18.479-394.227,4.928-86.237-136.747-236.536-214.361-247.624-104.716-16.015-209.433-34.495-263.639,0-20.943,9.855-38.191,20.943-50.51,32.031-44.351,35.727-49.278,103.485-17.248,171.242,104.717,218.057,56.67,301.83,72.686,448.433,3.7,34.494,27.1,61.6,59.134,64.062,107.18,9.855,202.041,54.206,346.18,34.495,11.087-2.464,24.639-2.464,35.727-11.088Z",
    transform: "translate(646.076 62.975)",
    fill: "#4eb0ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3549",
    "data-name": "Path 3549",
    d: "M200.167,289.7,106.538,644.5C95.451,687.622,149.657,745.525,201.4,745.525H348c28.335,0,38.191-25.871,22.175-52.974l-20.943-34.495L283.94,638.344C282.708,638.344,304.884,382.1,200.167,289.7Z",
    transform: "translate(559.547 162.428)",
    fill: "#4eb0ce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116",
    transform: "translate(812.836 519.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3550",
    "data-name": "Path 3550",
    d: "M152.777,662.324c32.031,0,96.093,0,250.088-25.871,23.407-3.7,43.119-28.335,40.655-50.51l-27.1-193.418c0-4.928,0-9.856,1.232-14.784,2.464-11.088,13.552-19.711,23.407-19.711L590.123,295.2c7.392,0,19.711,67.758,19.711,75.149,23.407,290.742,18.479,322.774-8.624,354.8l-7.392,7.392-2.464,3.7c-48.046,51.743-320.309,32.031-447.2,13.552H129.37c-8.624-1.232-13.552-8.624-11.088-17.247l13.552-50.511C131.834,670.948,142.922,663.556,152.777,662.324Z",
    transform: "translate(-111.039 -295.2)",
    fill: "#4eb0ce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115",
    transform: "translate(0 130.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3551",
    "data-name": "Path 3551",
    d: "M399.083,656.145c-93.629,0-195.881-9.856-253.783-17.247H130.516c-9.856-1.232-16.015-9.855-12.32-20.943l13.552-50.51c1.232-6.16,4.928-11.088,9.856-14.784s11.088-6.16,16.016-6.16h4.928c32.031,0,98.557-1.232,245.16-25.871,9.856-1.232,19.711-7.392,27.1-17.247,7.392-8.624,11.088-19.711,9.856-29.567l-23.407-163.85c0-1.232,1.232-3.7,2.464-3.7,1.232-1.232,3.7,0,3.7,1.232l23.407,163.85c1.232,11.087-2.464,23.407-11.088,34.495s-20.943,17.247-33.263,19.711c-146.6,24.639-213.129,25.871-245.16,25.871h-4.928a17.65,17.65,0,0,0-12.32,4.928,17.941,17.941,0,0,0-7.392,11.088l-13.552,50.51c-2.464,7.391,2.464,14.783,8.624,14.783h14.783c103.485,14.784,356.036,33.263,432.417-6.16,1.232-1.232,3.7,0,3.7,1.232s-1.232,3.7-2.464,3.7C545.686,648.753,475.464,656.145,399.083,656.145Z",
    transform: "translate(-117.112 -305.759)",
    fill: "#316d80"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121",
    transform: "translate(330.645 998.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3552",
    "data-name": "Path 3552",
    d: "M779.477,557.679l-33.263,22.175c-65.294-40.655-119.5-48.047-216.825-38.191L172.122,494.849c-23.407-14.784-46.814-29.567-70.222-46.814,6.16-46.814,35.727-88.7,98.557-97.325,177.4-23.407,349.876-29.567,524.814,34.495,48.046,17.247,73.918,56.67,85.005,93.629C817.668,508.4,805.348,540.431,779.477,557.679Z",
    transform: "translate(192.885 -331.801)",
    fill: "#331f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3553",
    "data-name": "Path 3553",
    d: "M268.041,605.526c-98.557-9.856-61.6-64.062-126.892-24.64l-29.567-20.943C83.247,540.232,70.927,504.5,82.015,472.474c12.32-34.495,36.959-70.222,82.541-87.469,174.938-64.062,347.412-57.9,524.814-34.494,62.83,8.624,91.165,50.51,98.557,97.324C764.52,465.082,985.041,590.742,960.4,605.525Z",
    transform: "translate(-77.972 -334.065)",
    fill: "#331f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3554",
    "data-name": "Path 3554",
    d: "M91.4,380.686c119.5,33.263,110.876,28.335,137.979,38.191l16.016-66.526c1.232-4.928-8.624,6.16-16.016,7.392L107.415,338.8Z",
    transform: "translate(74.03 -280.468)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118",
    transform: "translate(95.208 7.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3555",
    "data-name": "Path 3555",
    d: "M191.748,433.957l-73.918,35.727C99.351,478.307,88.264,470.915,85.8,458.6L218.852,335.4l22.175,33.263c3.7,6.16,3.7,13.551-2.464,18.479Z",
    transform: "translate(-84.568 -326.606)",
    fill: "#2186c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    d: "M219.983,343.48l-3.7-6.16c-2.464-3.7-8.624-3.7-13.552,1.232L100.484,434.645C89.4,445.733,85.7,456.82,85.7,465.444Z",
    transform: "translate(-85.7 -334.686)",
    fill: "#000543"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3557",
    "data-name": "Path 3557",
    d: "M111.813,338.8,95.8,354.813a6.1,6.1,0,1,0,8.624,8.624l16.016-16.015a6.1,6.1,0,0,0-8.624-8.624Z",
    transform: "translate(7.687 -309.06)",
    fill: "#000543"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119",
    transform: "translate(0.241 93.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    d: "M315.4,407.881c-78.845,6.16-123.2,7.392-173.706,7.392L134.3,351.211c0-4.928,6.16-8.624,13.552-7.392l162.618,27.1C353.589,379.546,356.053,405.418,315.4,407.881Z",
    transform: "translate(559.399 -320.116)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M742.123,357.148C542.546,332.509,330.649,347.293,166.8,343.6c-50.51-1.232-91.165,14.783-88.7,65.293,2.464,48.046,41.887,109.644,88.7,107.181,107.18-3.7,543.294-50.51,582.716-50.51C894.886,463.1,844.376,370.7,742.123,357.148Z",
    transform: "translate(-77.991 -332.212)",
    fill: "#4f3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M698.911,375.235c-20.943-4.928-71.454-36.959-211.9-33.263-41.887,1.232-99.789,14.784-140.443,8.624-16.015-2.464-28.335,7.392-44.35,6.16-25.871-1.232-54.206-4.928-80.077-4.928-13.552,0-27.1-3.7-41.887-6.16-25.871-3.7-54.206,1.232-77.614,12.319-6.16,2.464-20.943,7.392-20.943,17.247,0,11.088,13.551,9.855,19.711,14.784,4.928,2.464,7.392,7.392,11.088,11.087,4.928,3.7,13.552,4.928,19.711,4.928,57.9,1.232,115.8-12.319,173.706-19.711,54.206-6.16,108.413-7.392,162.618-7.392h73.918Z",
    transform: "translate(-36.011 -341.676)",
    fill: "#4f3563"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120",
    transform: "translate(254.594 24.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    d: "M197.963,338.125c200.809-1.232,409.01,40.654,572.861,55.438,50.51,4.928,86.237,50.511,77.613,99.789C841.046,540.166,796.7,572.2,749.881,564.8,643.932,547.558,227.53,453.928,189.34,449,43.968,430.521,93.247,338.125,197.963,338.125Z",
    transform: "translate(-98.638 -313.283)",
    fill: "#6e5082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    d: "M167.177,346.142c9.856,0,20.943,3.7,30.8,4.928,33.263,3.7,65.294-17.247,98.557-14.784,28.335,2.464,54.206,20.944,83.773,23.407,23.407,1.232,46.815-8.624,70.222-8.624,36.959,0,70.222,28.335,108.412,27.1,16.016,0,33.263-4.928,49.278-2.464,18.479,3.7,32.031,18.479,49.278,25.871,12.32,4.927,27.1,4.927,40.655,7.391a127.613,127.613,0,0,1,83.773,50.51c-14.784,6.16-32.031,4.928-48.046,2.464C685.832,454.554,639.018,441,592.2,432.379,464.079,407.74,332.26,420.059,202.9,411.436c-19.711-1.232-91.165-1.232-99.789-24.639S151.162,344.91,167.177,346.142Z",
    transform: "translate(-57.996 -336.084)",
    fill: "#6e5082"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    d: "M194.777,339.6H804.6L692.489,710.42,114.7,778.178Z",
    transform: "translate(668.421 727.276)",
    fill: "#8b5e5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    d: "M240.9,521.93C216.256,640.2,45.014,778.177,121.4,778.177c215.593,0,303.062-135.515,327.7-253.783S415.833,339.6,340.684,339.6C263.07,339.6,265.534,403.662,240.9,521.93Z",
    transform: "translate(523.747 727.275)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122",
    transform: "translate(722.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3565",
    "data-name": "Path 3565",
    d: "M110.146,365.108a277.732,277.732,0,0,0,7.392,44.35c1.232,4.928,2.464,8.624,7.392,11.087a11.106,11.106,0,0,0,6.16,1.232q-3.7-27.719,7.392-51.742c19.711,8.624,76.381,32.031,144.139,27.1l-1.232,30.8c-1.232,32.031-2.464,38.191-29.567,52.974-32.031,17.247-88.7,25.871-92.4,25.871l17.247,56.67c7.392,16.015,29.567,29.567,45.582,25.871,9.856-2.464,28.335-4.928,44.351-9.855,13.552-3.7,25.871-8.624,32.031-16.015,7.392-7.392,20.943-25.871,25.871-35.727,9.856-19.711,8.624-45.582,2.464-66.526l-12.32-48.046c12.32-2.464,25.871,7.392,29.567,22.175,2.464,8.624,0,18.479-3.7,24.639l11.088,38.191c3.7-3.7,8.624-4.928,12.32-7.392,8.624-8.624,1.232-24.639,6.16-35.727,3.7-7.392,12.32-12.32,14.783-19.711,2.464-8.624-2.464-17.247-8.624-23.407-2.464-3.7-6.16-6.16-8.624-9.856,1.232-17.247,8.624-35.727,0-50.51-3.7-4.928-7.392-8.624-11.087-13.552-2.464-3.7-3.7-8.624-4.928-13.552-11.087-27.1-38.191-29.567-60.366-39.423-19.711-8.624-34.495-29.567-56.67-30.8-1.232-1.232-3.7-1.232-4.928-1.232s-3.7,1.232-4.928,1.232c-6.16,1.232-11.088,3.7-16.015,6.16-3.7-1.232-6.16-2.464-9.856-3.7-11.088-1.232-17.247,14.783-27.1,18.479-7.392,2.464-16.015-1.232-22.175,2.464-7.392,3.7-9.856,12.32-9.856,20.943-1.232,7.392-1.232,17.247-6.16,23.407a67.738,67.738,0,0,1-11.088,8.624C110.146,340.468,108.914,354.02,110.146,365.108ZM218.558,521.566s-14.784,6.16-20.943-7.392l35.727-12.32C233.342,509.247,232.11,516.638,218.558,521.566Z",
    transform: "translate(-109.769 -253)",
    fill: "#000543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3566",
    "data-name": "Path 3566",
    d: "M112.349,314.243a4.525,4.525,0,0,0,1.232,3.7l19.711-4.928c2.464-1.232,6.16,1.232,6.16,3.7,1.232,2.464-1.232,6.16-3.7,6.16l-19.711,4.928,23.407,66.526c0,1.232,1.232,2.464,1.232,4.928,3.7,0,59.134-8.624,92.4-25.871,27.1-14.784,28.335-20.943,29.567-52.974l1.232-30.8c-67.758,3.7-124.428-18.479-144.139-27.1A93.561,93.561,0,0,0,112.349,314.243Zm101.021-7.392-19.711,4.928c-2.464,1.232-6.16-1.232-6.16-3.7-1.232-2.464,1.232-6.16,3.7-6.16L210.906,297c2.464-1.232,6.16,1.232,6.16,3.7C218.3,303.155,215.833,306.851,213.369,306.851Zm-2.464,7.392c3.7-1.232,7.392,2.464,8.624,8.624,1.232,4.928,0,9.855-3.7,11.087s-7.392-2.464-8.624-8.624S207.21,314.243,210.906,314.243Zm-46.814,50.51v-2.464a10.732,10.732,0,0,0,9.856,7.392h11.088a8.318,8.318,0,0,0,7.392-4.928v1.232c2.464,6.16-1.232,12.32-7.392,12.32H173.947C167.787,377.072,162.859,370.913,164.091,364.753Zm-19.711-27.1c1.232,4.928,0,9.856-3.7,11.088s-7.392-2.464-8.624-8.624c-1.232-4.928,0-9.855,3.7-11.087C139.452,329.026,143.148,332.722,144.38,337.65Z",
    transform: "translate(-91.029 -145.465)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3567",
    "data-name": "Path 3567",
    d: "M179.27,381.019c9.856-19.711,8.624-45.582,2.464-66.526l-12.32-48.046c12.32-2.464,25.871,7.392,29.567,22.175,2.464,8.624,0,18.479-3.7,24.639l11.088,38.191,27.1,98.557a44.7,44.7,0,0,1-34.495,56.67l-11.088,2.464c-23.407,4.928-46.814-8.624-52.974-32.031L122.6,432.761c13.552-3.7,25.871-8.624,32.031-16.015S174.343,390.875,179.27,381.019Z",
    transform: "translate(35.467 -105.061)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3568",
    "data-name": "Path 3568",
    d: "M143.772,275.457l-19.711,4.928c-2.464,1.232-6.16-1.232-6.16-3.7-1.232-2.464,1.232-6.16,3.7-6.16l19.711-4.928c2.464-1.232,6.16,1.232,6.16,3.7C148.7,271.76,146.236,275.457,143.772,275.457Z",
    transform: "translate(-21.432 -114.071)",
    fill: "#000543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3569",
    "data-name": "Path 3569",
    d: "M135.008,267c2.464-1.232,6.16,1.232,6.16,3.7,1.232,2.464-1.232,6.16-3.7,6.16l-19.711,4.928c-2.464,1.232-6.16-1.232-6.16-3.7-1.232-2.464,1.232-6.16,3.7-6.16C115.3,270.7,135.008,267,135.008,267Z",
    transform: "translate(-92.745 -98.223)",
    fill: "#000543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3570",
    "data-name": "Path 3570",
    d: "M125.844,276.524c1.232,4.928,0,9.856-3.7,11.088s-7.392-2.464-8.624-8.624c-1.232-4.928,0-9.855,3.7-11.087C120.916,267.9,124.612,271.6,125.844,276.524Z",
    transform: "translate(-72.493 -84.339)",
    fill: "#000543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3571",
    "data-name": "Path 3571",
    d: "M123.32,266.917c3.7-1.232,7.392,2.464,8.624,8.624,1.232,4.928,0,9.855-3.7,11.087s-7.392-2.464-8.624-8.624S119.624,266.917,123.32,266.917Z",
    transform: "translate(-3.444 -98.139)",
    fill: "#000543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3572",
    "data-name": "Path 3572",
    d: "M125.73,277.992h11.088a8.318,8.318,0,0,0,7.392-4.928V274.3c2.464,6.16-1.232,12.32-7.392,12.32H125.73c-6.16,0-11.088-6.16-9.856-13.552V270.6C117.107,275.528,120.8,277.992,125.73,277.992Z",
    transform: "translate(-42.813 -53.776)",
    fill: "#fa694f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3573",
    "data-name": "Path 3573",
    d: "M137.843,292.911s-14.784,6.16-20.943-7.392L152.627,273.2C152.627,280.592,151.395,287.983,137.843,292.911Z",
    transform: "translate(-29.055 -24.345)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124",
    transform: "translate(127.559 538.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3574",
    "data-name": "Path 3574",
    d: "M122.347,368.695H601.579a17.247,17.247,0,0,0,0-34.495H122.347a17.247,17.247,0,1,0,0,34.495Z",
    transform: "translate(432.194 127.785)",
    fill: "#91b4de"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3575",
    "data-name": "Path 3575",
    d: "M158.642,296.7H106.9c25.871,0,51.742,18.479,57.9,43.119L276.91,751.292c6.16,23.407-8.624,43.119-34.495,43.119h51.742c25.871,0,40.655-18.479,34.495-43.119L216.544,339.819C209.152,316.411,183.281,296.7,158.642,296.7Z",
    transform: "translate(452.569 -296.7)",
    fill: "#91b4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3576",
    "data-name": "Path 3576",
    d: "M815.606,751.292,703.5,339.819c-6.16-23.407-32.031-43.119-57.9-43.119H97.374c-25.871,0-40.655,18.479-34.495,43.119L174.987,751.292c6.16,23.407,32.031,43.119,57.9,43.119H781.111C805.75,793.179,821.765,774.7,815.606,751.292Z",
    transform: "translate(-61.487 -296.7)",
    fill: "#d7e1fc"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139",
    transform: "translate(1528.378 2064.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3577",
    "data-name": "Path 3577",
    d: "M2929.931,2078.134c66.526,4.928,115.8,6.16,163.851-19.711,20.944-11.087,25.871-17.247,30.8-40.654,12.32-60.366-46.814-98.557-101.021-105.948-48.046-6.16-97.324,1.232-142.907-13.552-19.711-6.16-40.654-18.48-38.19-45.583a57.615,57.615,0,0,1,29.567-41.887l170.01-99.789c18.479-11.088,34.495-24.64,45.583-43.119,51.742-85.005-55.438-154-136.748-137.98-80.076,16.015-144.139,76.382-222.984,96.093-17.248,3.7-35.727,3.7-50.51-6.16-35.727-20.943-27.1-62.83-14.784-97.325a2270.508,2270.508,0,0,1,114.572-283.35c13.552-28.335,27.1-56.67,28.335-87.469s-14.784-65.294-44.351-75.15c-16.015-4.928-34.5-2.464-50.51,1.232-114.572,29.567-205.737,123.2-256.247,227.912-14.783,30.8-40.654,54.206-73.917,60.366-80.077,16.015-109.644-80.077-102.253-150.3,29.567-290.742,304.294-521.119,267.335-825.412-8.624-65.294-40.654-125.66-96.092-161.386-117.036-73.918-245.16,12.319-325.237,108.412C2044.151,434.7,1986.25,550.5,1952.987,672.469c-8.624,34.495-17.247,70.222-43.119,94.861-14.784,13.552-34.495,20.943-54.206,18.479-28.335-4.928-39.423-28.335-48.046-50.51-32.031-78.845-71.453-157.691-82.542-241.464-9.856-81.309-81.309-94.861-131.82-75.149-51.742,19.711-104.717,35.727-140.443,129.356C1393.678,704.5,1371.5,796.9,1350.559,1080.247c-3.7,46.814-83.773,49.278-105.948-3.7-60.366-145.371-76.381-288.278-147.835-427.49S920.606,380.494,778.93,316.432c-30.8-13.552-65.294-24.639-97.325-12.32-44.351,16.016-62.83,68.99-68.99,115.8-25.871,213.129,101.021,410.242,179.866,611.052,16.016,41.886,30.8,85,24.639,129.355s-38.191,87.469-82.541,92.4c-23.407,2.464-46.815-4.928-67.758-16.015-102.253-49.278-179.866-151.531-295.67-165.082-22.175-2.464-44.351,0-62.83,11.087-51.742,29.567-45.583,88.7-28.335,135.515,72.685,193.418,283.35,293.206,420.1,445.969,19.711,20.944,25.871,52.974,12.319,77.613s-36.959,24.639-57.9,22.175C501.74,1750.432,369.92,1656.8,223.317,1614.917c-33.263-9.856-72.685,195.881-28.335,231.608,1.232,1.232,2.464,1.232,2.464,2.464C353.9,1977.112,552.25,2043.638,754.291,2046.1Z",
    transform: "translate(-175.194 -201.142)",
    fill: "#4e6fd8",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126",
    transform: "translate(505.181 90.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3578",
    "data-name": "Path 3578",
    d: "M1184.519,1989.912h-2.464c-2.464-1.232-3.7-2.464-3.7-4.928-6.16-49.278-38.191-96.093-94.861-145.371-12.319-11.088-25.871-20.944-38.191-30.8-34.495-27.1-70.222-56.67-97.324-92.4-48.046-64.062-64.062-144.139-80.077-221.752-14.784-70.222-29.567-142.907-67.758-203.273-30.8-46.814-73.918-85.005-117.036-120.732-46.814-40.654-96.093-82.542-126.892-136.747-25.871-45.583-36.959-97.325-48.046-146.6-4.928-23.407-11.088-46.814-17.247-70.222a522.527,522.527,0,0,0-81.309-166.315c-16.015-22.175-34.495-44.35-51.742-65.294-29.567-35.727-60.366-72.685-82.541-113.34C233.447,392.062,223.592,298.433,216.2,214.66c0-3.7,2.464-6.16,4.928-6.16,3.7,0,6.16,2.464,6.16,4.928,7.392,82.541,16.016,174.938,57.9,252.552,20.943,40.655,51.742,76.381,81.309,112.109,17.247,20.943,35.727,43.119,52.974,66.526,36.959,51.742,65.294,109.644,82.541,170.01,7.392,23.407,12.319,48.046,17.247,71.453,11.088,49.278,22.175,99.789,46.815,142.907,29.567,52.974,77.613,94.861,124.428,134.284,43.119,36.959,87.469,75.15,119.5,123.2,39.423,61.6,54.206,135.515,68.99,206.969,16.016,76.382,32.031,155.227,77.613,216.825,25.871,34.495,61.6,62.83,94.861,89.933,12.32,9.855,25.871,20.944,38.191,32.031,55.438,46.814,87.469,93.628,97.324,140.443,23.407-32.031,8.624-80.077-3.7-107.18-6.16-13.552-13.551-27.1-20.943-40.655-14.784-27.1-29.567-54.206-34.495-85.005-4.928-32.031,0-65.293,6.16-96.092,4.928-29.567,11.088-60.366,6.16-89.933-7.392-45.583-35.727-82.541-66.526-121.964-13.552-17.247-25.871-34.495-38.191-51.742-44.351-68.99-61.6-155.227-46.814-236.536,0-3.7,3.7-4.928,7.392-4.928s4.928,3.7,4.928,7.392c-14.784,77.613,2.464,161.386,44.351,227.912,11.088,17.247,24.639,34.495,36.959,50.51,29.567,38.191,61.6,78.845,68.99,128.123,4.928,32.031-1.232,62.83-6.16,93.629-6.16,32.031-11.087,61.6-6.16,92.4,4.927,28.335,18.479,54.206,33.263,81.309,7.392,13.552,14.783,27.1,20.943,40.654,24.639,56.67,22.175,102.252-7.392,130.588C1188.216,1989.912,1185.751,1989.912,1184.519,1989.912Z",
    transform: "translate(-216.2 -208.5)",
    fill: "#89e5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127",
    transform: "translate(1446.564 221.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3579",
    "data-name": "Path 3579",
    d: "M338.03,1881.556h0c-3.7,0-6.16-3.7-6.16-6.16,2.464-27.1,11.088-55.438,18.479-81.309,14.784-50.51,29.567-97.325,9.856-141.676-2.464-6.16-6.16-12.319-9.856-18.479-4.928-9.855-11.087-19.711-13.551-30.8-9.855-36.959,8.624-71.453,28.335-104.717a273.319,273.319,0,0,0,24.639-50.51c17.247-51.742,2.464-103.484-14.784-160.154-9.855-34.495-20.943-71.454-23.407-107.181-2.464-50.51,11.088-99.789,24.639-146.6A697.009,697.009,0,0,0,394.7,961.283c13.552-67.758,9.855-137.979-8.624-204.505-9.855-33.263-23.407-66.526-36.959-98.557-12.32-29.567-25.871-60.366-35.727-92.4C278.9,453.716,287.519,328.056,338.029,222.108c1.232-2.464,4.928-3.7,8.624-2.464,2.464,1.232,3.7,4.928,2.464,8.624-49.278,103.485-57.9,225.448-24.639,335.093A822.072,822.072,0,0,0,360.2,654.525c13.551,32.031,28.335,65.294,38.191,99.789,19.711,67.758,23.407,140.443,8.624,209.433-4.928,24.639-12.319,49.278-18.479,72.685-13.552,46.814-27.1,94.861-24.639,142.907,2.464,34.495,12.32,70.222,22.175,104.716,16.015,55.438,33.263,112.108,14.784,167.547-6.16,18.479-16.015,35.727-25.871,52.974-18.479,32.031-35.727,62.83-27.1,96.093,2.464,9.855,7.392,18.48,12.32,28.335,3.7,6.16,7.392,12.319,9.855,18.479,20.943,48.047,6.16,99.789-8.624,150.3-7.392,25.871-16.015,52.974-18.479,80.077C344.189,1879.092,341.725,1881.556,338.03,1881.556Z",
    transform: "translate(-292.614 -219.161)",
    fill: "#89e5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128",
    transform: "translate(1525.243 39.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3580",
    "data-name": "Path 3580",
    d: "M305.16,2045.69h-1.232c-3.7-1.232-4.928-3.7-4.928-7.392,14.784-65.294,54.206-119.5,92.4-173.706,34.495-48.046,68.99-97.325,86.237-153.995a666.532,666.532,0,0,0,14.784-67.758c3.7-22.175,7.392-44.351,13.552-65.294,16.015-56.67,48.046-105.949,80.077-155.227,7.392-12.32,16.015-24.639,23.407-36.959,33.263-52.974,70.222-124.428,64.062-198.345-1.232-16.016-4.928-32.031-8.624-46.814-4.928-24.639-11.087-49.278-8.624-75.15,3.7-41.887,27.1-83.773,68.99-125.66,14.784-13.552,30.8-27.1,45.583-39.423,20.943-17.247,41.886-34.495,60.366-54.206a300.19,300.19,0,0,0,71.454-131.82c11.088-41.886,12.319-86.237,13.552-128.124q1.848-35.111,3.7-70.222c11.087-112.108,55.438-221.752,125.66-309.222a6.16,6.16,0,0,1,9.856,7.392C987.665,300,943.315,407.185,932.227,516.829a664.741,664.741,0,0,0-3.7,68.99c-1.232,43.119-3.7,87.469-14.784,130.588-13.551,50.51-38.191,98.557-73.917,136.747-18.48,19.711-40.655,38.191-61.6,55.438-14.783,12.319-30.8,25.871-45.583,39.423-40.655,39.423-62.83,78.845-65.294,117.036-1.232,23.407,3.7,46.814,8.624,71.453,3.7,16.016,7.392,32.031,8.624,48.046,7.392,77.613-30.8,151.531-65.293,205.737-7.392,12.32-16.015,24.639-23.407,36.959-30.8,48.046-62.83,97.325-78.845,151.531-6.16,20.943-9.855,43.119-13.552,64.062-3.7,23.407-7.392,46.814-14.783,70.222-17.247,57.9-52.974,108.412-88.7,157.691-36.959,52.974-76.382,107.181-89.933,168.779C310.087,2044.458,307.624,2045.69,305.16,2045.69Z",
    transform: "translate(-299 -204.334)",
    fill: "#6d72a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129",
    transform: "translate(1536.33 576.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3581",
    "data-name": "Path 3581",
    d: "M306.06,1524.754h0c-3.7,0-6.16-3.7-6.16-7.392,11.088-81.31,23.407-165.083,51.743-242.7l14.784-36.959c11.087-28.335,23.407-56.67,29.567-86.237,6.16-33.263,6.16-67.758,6.16-101.021,0-30.8,0-62.83,4.928-94.861,6.16-36.959,19.711-72.686,33.263-107.181,19.711-51.742,38.191-101.021,34.495-153.995-2.464-29.567-12.319-59.134-22.175-87.469-3.7-12.319-8.624-24.639-12.32-36.959-30.8-104.716-20.943-220.52,27.1-319.077,1.232-2.464,4.928-3.7,8.624-2.464,2.464,1.232,3.7,4.928,2.464,8.624-46.814,94.861-55.438,208.2-25.871,310.454,3.7,12.319,7.392,24.639,12.32,36.959,9.855,28.335,19.711,59.134,22.175,89.933,4.928,55.438-16.015,108.412-34.495,158.923-13.552,34.495-25.871,68.99-32.031,104.716-4.928,30.8-4.928,61.6-4.928,92.4,0,34.495,0,68.99-6.16,103.484-6.16,30.8-18.479,60.366-29.567,88.7l-14.784,36.959c-28.335,77.613-39.423,160.155-51.743,240.232C310.988,1523.522,308.524,1524.754,306.06,1524.754Z",
    transform: "translate(-299.9 -247.961)",
    fill: "#89e5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130",
    transform: "translate(1537.1 1160.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3582",
    "data-name": "Path 3582",
    d: "M306.584,1030.092a6.776,6.776,0,0,1-6.16-3.7q-1.848-5.544,3.7-7.392c29.567-12.319,46.814-41.886,65.294-71.453,11.087-18.48,22.175-36.959,35.727-52.974,17.247-18.48,38.191-32.031,57.9-45.583,22.175-14.783,43.119-28.335,59.134-46.814,22.175-25.871,32.031-60.365,41.887-94.861,9.856-35.727,20.943-72.685,45.583-101.021,17.247-18.479,38.191-32.031,59.134-45.583,3.7-2.464,8.624-4.928,12.32-7.392,96.093-61.6,174.938-151.531,224.216-255.016,1.232-2.464,4.928-3.7,8.624-2.464,2.464,1.232,3.7,4.928,2.464,8.624C867.125,409.184,785.816,501.581,688.491,564.411c-3.7,2.464-8.624,4.928-12.319,7.392-19.711,12.32-40.654,25.871-56.67,43.119-23.407,25.871-33.263,60.366-43.119,96.093-9.856,34.495-20.943,70.222-44.351,98.557-17.247,20.943-40.655,35.727-62.83,49.278-19.711,12.32-40.655,25.871-55.438,43.119-13.552,14.783-24.639,33.263-34.495,50.51-18.479,30.8-36.959,62.83-71.453,77.613C307.816,1028.859,306.584,1030.092,306.584,1030.092Z",
    transform: "translate(-299.962 -295.361)",
    fill: "#89e5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131",
    transform: "translate(1595.354 896.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3583",
    "data-name": "Path 3583",
    d: "M310.962,1261.931a4.525,4.525,0,0,1-3.7-1.232c-2.464-1.232-3.7-4.928-1.232-8.624,30.8-48.046,88.7-87.469,112.109-102.252,6.16-3.7,12.319-7.392,17.247-11.088,32.031-19.711,52.974-32.031,80.077-62.83,24.639-25.871,56.67-39.423,88.7-52.974,22.175-9.855,45.583-19.711,65.294-33.263,39.423-28.335,62.83-68.99,87.469-113.34,20.944-36.959,43.119-76.382,75.15-105.949,25.871-23.407,56.67-39.423,86.237-54.206,14.784-7.392,29.567-16.015,44.35-23.407,56.67-34.495,104.717-82.541,136.748-141.675,14.783-25.871,25.871-52.974,36.959-80.077s23.407-55.438,38.19-82.541c29.567-51.742,86.237-105.949,149.067-114.572,3.7,0,6.16,2.464,6.16,4.928,0,3.7-2.464,6.16-4.928,6.16-59.134,7.392-113.34,60.366-140.443,108.412-14.783,25.871-27.1,54.206-38.19,81.309s-23.407,55.438-38.191,81.309c-33.263,60.366-82.541,109.644-141.675,145.371-14.784,8.624-29.567,17.247-44.351,24.639-29.567,14.784-59.134,30.8-83.773,52.974-30.8,28.335-52.974,65.294-72.685,102.253-24.639,43.119-49.278,87.469-91.165,117.036-20.944,14.784-44.351,24.639-67.758,34.495-32.031,13.552-61.6,27.1-85,50.51-28.335,30.8-51.742,45.583-82.542,64.062-4.928,3.7-11.087,7.392-17.247,11.088-23.407,14.783-78.845,52.974-108.412,98.557C314.657,1260.7,313.425,1261.931,310.962,1261.931Z",
    transform: "translate(-304.691 -273.9)",
    fill: "#6d72a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132",
    transform: "translate(1679.986 1402.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3584",
    "data-name": "Path 3584",
    d: "M316.972,785.609c-1.232,0-2.464,0-2.464-1.232-2.464-1.232-3.7-4.928-2.464-8.624,17.247-33.263,54.206-46.814,88.7-59.134,18.479-6.16,36.959-13.552,52.974-22.175,20.943-12.32,39.423-32.031,56.67-50.511,28.335-29.567,57.9-60.366,99.788-64.062a113.989,113.989,0,0,1,35.727,2.464c7.392,1.232,14.784,2.464,22.175,2.464,34.495,1.232,68.99-13.552,92.4-38.191A130.457,130.457,0,0,0,772.8,531.825c7.392-9.855,16.016-20.944,27.1-28.335,24.639-18.479,56.67-18.479,86.237-18.479,12.32,0,24.639,0,35.727-1.232,48.047-4.928,92.4-33.263,118.268-72.685,4.927-7.392,9.855-17.247,14.783-27.1,16.015-32.031,34.495-68.99,65.294-68.99a6.16,6.16,0,1,1,0,12.319c-23.407,0-39.423,33.263-54.206,62.83-4.928,11.088-9.855,20.944-14.784,28.335-27.1,43.119-76.381,73.917-126.891,78.845-12.32,1.232-24.639,1.232-36.959,1.232-29.567,0-57.9,0-78.846,16.015-9.856,7.392-17.247,16.016-24.639,25.872a156.1,156.1,0,0,1-13.552,16.015C744.462,584.8,707.5,599.582,669.312,598.35c-7.392,0-16.016-1.232-23.407-2.464-11.088-1.232-22.175-2.464-33.263-2.464-36.959,3.7-64.062,30.8-92.4,60.366-18.479,18.479-36.959,39.423-59.134,51.742-17.247,9.856-35.727,17.247-55.438,23.407-34.495,12.32-66.526,23.407-82.541,52.974C320.668,784.376,318.2,785.609,316.972,785.609Z",
    transform: "translate(-311.561 -315)",
    fill: "#89e5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    transform: "translate(1673.982 1376.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3585",
    "data-name": "Path 3585",
    d: "M317.561,799.939a6.776,6.776,0,0,1-6.16-3.7c-1.232-3.7,1.232-6.16,3.7-7.392,65.294-22.175,135.515-35.727,203.273-38.191,11.088,0,22.175-1.232,33.263-1.232,56.67-1.232,110.877-2.464,157.691-34.495l40.655-29.567c35.727-27.1,71.453-55.438,115.8-64.062,17.247-3.7,35.727-4.928,52.974-4.928,11.088,0,22.175-1.232,33.263-2.464,82.541-8.624,150.3-62.83,192.186-107.181,4.928-4.928,8.624-9.855,13.552-14.784,22.175-23.407,44.351-46.814,73.917-61.6,27.1-13.551,57.9-17.247,87.469-20.943,35.727-3.7,68.99-8.624,96.093-27.1,11.088-7.392,19.711-17.247,29.567-27.1,8.624-8.624,17.247-17.247,27.1-24.639,20.944-16.015,54.206-25.871,77.613-8.624,2.464,2.464,3.7,6.16,1.232,8.624s-6.16,3.7-8.624,1.232c-18.479-13.551-45.583-4.928-62.83,8.624-8.624,7.392-17.248,16.015-25.871,23.407-9.856,9.855-19.712,19.711-30.8,28.335-29.567,20.943-66.526,25.871-102.252,29.567-28.334,3.7-57.9,7.392-83.773,19.711-27.1,13.552-49.278,36.959-70.222,59.134-4.927,4.928-8.624,9.855-13.551,14.784C1090,580.649,1021.008,618.84,953.251,626.231c-11.088,1.232-22.175,1.232-33.263,2.464-17.247,0-34.495,1.232-50.51,4.928-41.886,8.624-76.382,35.727-110.876,62.83-13.552,9.855-27.1,20.944-41.887,30.8-49.278,33.263-105.948,34.495-163.85,35.727-11.088,0-22.175,0-33.263,1.232-66.526,2.464-135.515,16.015-199.577,36.959C318.793,799.939,318.793,799.939,317.561,799.939Z",
    transform: "translate(-311.073 -312.863)",
    fill: "#6d72a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134",
    transform: "translate(1707.572 1678.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3586",
    "data-name": "Path 3586",
    d: "M319.96,525.223c-2.464,0-4.928-2.464-6.16-4.928,0-3.7,1.232-6.16,4.928-7.391,71.453-11.088,146.6-9.856,218.057-9.856,113.34,1.232,231.608,2.464,336.324-44.35,13.552-6.16,27.1-12.319,40.655-19.711,43.119-22.175,88.7-44.351,136.748-40.655,13.552,1.232,28.335,4.928,41.886,7.392,17.247,3.7,33.263,8.624,49.279,7.391,48.046-1.232,88.7-36.958,125.66-73.917a6.1,6.1,0,0,1,8.624,8.624c-39.423,38.191-81.309,76.382-134.284,77.613-18.479,0-35.727-3.7-52.974-7.392a221.915,221.915,0,0,0-39.423-7.392c-45.583-3.7-88.7,18.48-130.588,39.423-13.552,6.16-27.1,13.552-40.655,19.711-107.181,46.814-226.68,45.582-341.253,44.351-70.221,1.231-144.139,0-216.825,11.087Z",
    transform: "translate(-313.8 -337.35)",
    fill: "#6d72a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135",
    transform: "translate(608.344 1014.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3587",
    "data-name": "Path 3587",
    d: "M1084.8,1136.309a6.775,6.775,0,0,1-6.16-3.7c-12.32-35.727-41.887-64.062-94.861-92.4-8.624-4.928-17.247-8.624-25.871-13.552-33.263-16.015-67.758-33.263-94.861-60.366-14.784-14.784-27.1-33.263-38.191-49.279-12.319-18.479-25.871-38.191-43.119-54.206-19.711-18.48-45.582-30.8-70.222-41.887S662.24,797.521,641.3,780.274c-30.8-25.871-49.278-61.6-67.758-97.325a540.983,540.983,0,0,0-33.263-57.9c-35.727-51.742-87.469-88.7-137.979-124.428-12.319-8.624-23.407-17.247-35.727-25.871-51.742-39.423-124.428-99.789-141.675-183.562-1.232-3.7,1.232-6.16,4.928-7.392s6.16,1.232,7.392,4.928c16.015,80.077,86.237,139.211,136.747,176.17,11.087,8.624,23.407,17.247,34.495,25.871,51.742,36.959,104.717,75.15,141.675,128.124,12.319,18.479,23.407,39.423,33.263,59.134,18.479,35.727,35.727,68.99,65.294,93.629,19.711,17.247,44.351,28.335,66.526,39.423,24.639,12.32,51.742,24.639,72.685,44.351,18.479,16.015,32.031,35.727,44.351,55.438a355.116,355.116,0,0,0,36.959,48.047c25.871,25.871,59.134,41.886,91.165,57.9,8.624,4.928,17.247,8.624,27.1,13.552,35.727,18.48,83.773,48.047,101.021,98.557q1.849,5.544-3.7,7.392Q1086.65,1136.309,1084.8,1136.309Z",
    transform: "translate(-224.574 -283.474)",
    fill: "#89e5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136",
    transform: "translate(104.332 890.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3588",
    "data-name": "Path 3588",
    d: "M1525.728,1245.94c-22.175,0-43.119-14.784-62.83-28.335-12.319-8.624-24.639-17.247-36.959-22.175-18.479-7.392-41.886-8.624-62.83-9.855-30.8-1.232-62.83-2.464-86.237-23.407-8.624-7.392-13.552-16.016-19.712-24.64a149.454,149.454,0,0,0-12.319-17.247c-27.1-30.8-68.99-36.959-112.109-44.35s-88.7-13.552-118.268-45.583c-17.247-18.479-27.1-43.119-35.727-66.526-7.392-19.711-14.783-40.655-27.1-56.67-27.1-35.727-70.221-46.814-117.036-60.366-40.655-11.087-82.541-23.407-113.34-51.742-29.567-27.1-43.119-66.526-56.67-103.484-9.856-28.335-20.943-56.67-36.959-80.077-38.191-52.974-99.789-75.149-166.314-97.325-27.1-9.855-54.206-18.479-80.077-30.8C293.769,442.7,222.315,370.017,184.124,281.316c-1.232-2.464,0-6.16,3.7-7.392,2.464-1.232,6.16,0,7.392,3.7,36.959,85,105.948,156.459,190.954,195.881,24.639,11.087,52.974,20.943,78.845,29.567,65.294,22.175,131.819,45.582,172.474,102.252,18.479,24.639,28.335,55.438,39.423,83.773,13.552,36.959,25.871,72.685,52.974,98.557,28.335,27.1,68.99,38.191,108.413,49.278,45.582,12.32,93.629,25.871,123.2,64.062,13.552,17.247,20.943,39.423,29.567,60.366,8.624,23.407,17.247,45.583,33.263,62.83,27.1,29.568,67.757,35.727,112.108,41.887,44.351,7.392,89.933,14.783,119.5,48.046,4.928,6.16,8.624,12.32,13.552,17.247,6.16,8.624,11.088,16.016,18.479,22.175,19.711,18.479,48.046,19.711,78.845,20.943,22.175,1.232,45.583,2.464,67.758,11.088,13.552,6.16,27.1,14.783,39.423,23.407,23.407,16.015,45.583,30.8,68.99,24.639,3.7-1.232,6.16,1.232,7.392,3.7,1.232,3.7-1.232,6.16-3.7,7.391A160.717,160.717,0,0,1,1525.728,1245.94Z",
    transform: "translate(-183.662 -273.463)",
    fill: "#89e5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    transform: "translate(522.428 1543.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3589",
    "data-name": "Path 3589",
    d: "M1125.553,644.245h0L813.868,604.822c-36.959-4.927-77.613-9.855-110.876-32.031-8.624-6.16-16.016-12.32-24.639-18.48-7.392-6.16-14.783-12.319-23.407-17.247-29.567-19.711-67.758-24.639-104.716-29.567-43.119-6.16-87.469-11.087-120.732-40.654-12.319-9.855-20.943-22.175-30.8-34.495-4.928-6.16-8.624-11.088-13.552-17.247-39.423-46.814-99.789-76.382-161.386-76.382a6.16,6.16,0,1,1,0-12.319c65.294,1.232,129.356,30.8,171.242,81.309,4.928,6.16,9.856,12.32,13.552,17.247,8.624,12.32,17.247,23.407,28.335,33.263,30.8,27.1,71.454,32.031,114.572,38.191,38.191,4.927,77.613,9.855,109.644,30.8,8.624,6.16,17.247,12.32,24.639,18.48s14.783,12.319,23.407,17.247C739.95,582.648,780.6,588.808,815.1,592.5l310.454,39.423c3.7,0,6.16,3.7,4.928,6.16C1131.713,641.781,1129.25,644.245,1125.553,644.245Z",
    transform: "translate(-217.6 -326.4)",
    fill: "#89e5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138",
    transform: "translate(65.418 1536.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3590",
    "data-name": "Path 3590",
    d: "M1503.58,659.378h0c-65.294-11.088-131.82-16.015-197.113-16.015h-39.423c-61.6,1.232-124.428,2.464-183.562-18.48-8.624-2.464-17.247-6.16-25.871-9.855-12.32-4.928-24.639-9.855-36.959-13.552-35.727-9.855-76.381-8.624-115.8-6.16-57.9,2.464-117.036,4.927-162.618-30.8-11.087-8.624-19.711-18.479-28.335-28.335a164.6,164.6,0,0,0-25.871-24.639c-40.655-33.263-99.789-35.727-139.211-34.495-11.087,0-22.175,1.232-33.263,1.232-39.423,2.464-80.077,4.928-118.268-4.928C340.611,459.8,293.8,421.61,248.214,385.883c-8.624-7.392-17.247-13.552-25.871-20.944-71.454-55.438-39.423-45.582,7.392-9.855,8.624,7.392,17.247,13.552,25.871,20.944,44.351,35.727,89.933,71.453,144.139,85,36.959,8.624,76.381,7.392,114.572,4.928,11.087-1.232,22.175-1.232,33.263-1.232,41.887-1.232,103.484,1.232,147.835,36.959,9.856,7.392,18.479,17.247,27.1,25.871,8.624,9.855,17.247,18.48,27.1,25.871,41.886,33.263,97.325,30.8,155.227,28.335,39.423-1.232,81.309-3.7,118.268,7.392,13.552,3.7,25.871,8.624,38.191,13.551,8.624,3.7,16.015,6.16,24.639,9.856,56.67,19.711,119.5,18.479,179.866,17.247h39.423c66.526,0,133.052,4.928,198.345,16.016,3.7,0,4.928,3.7,4.928,7.391S1506.045,659.378,1503.58,659.378Z",
    transform: "translate(-180.504 -325.825)",
    fill: "#89e5b9"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162",
    transform: "translate(4074.915 2362.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140",
    transform: "translate(157.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3591",
    "data-name": "Path 3591",
    d: "M403.324,275.91H400.86a5.82,5.82,0,0,1-6.16-6.16V231.56a5.82,5.82,0,0,1,6.16-6.16h2.464a5.82,5.82,0,0,1,6.16,6.16V269.75C410.716,272.214,407.02,275.91,403.324,275.91Z",
    transform: "translate(-394.7 -225.4)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141",
    transform: "translate(76.382 21.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    d: "M405.347,257.444a6.774,6.774,0,0,1-6.16-3.7L388.1,235.269l1.232-4.928,3.7-2.464c3.7-1.232,7.391-1.232,8.624,2.464l9.855,16.016c1.232,3.7,1.232,7.392-2.464,8.623l-1.232,1.232C407.811,257.444,406.579,257.444,405.347,257.444Z",
    transform: "translate(-388.1 -227.14)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142",
    transform: "translate(20.207 80.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3593",
    "data-name": "Path 3593",
    d: "M421.236,264.708a4.524,4.524,0,0,1-3.7-1.232L386.741,245a6.5,6.5,0,0,1-2.464-8.624l1.232-1.232c1.232-3.7,6.16-3.7,8.624-2.464l30.8,18.479a6.5,6.5,0,0,1,2.464,8.624l-2.464,3.7-2.464,1.232Z",
    transform: "translate(-383.54 -231.94)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    transform: "translate(273.99 76.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3594",
    "data-name": "Path 3594",
    d: "M412.269,261.213a6.775,6.775,0,0,1-6.16-3.7l-1.232-1.232c-1.232-3.7-1.232-7.392,2.464-8.623l25.871-14.784c3.7-2.464,7.391-1.232,8.624,2.464l2.464,3.7v3.7a3.933,3.933,0,0,1-3.7,3.7l-25.872,14.783Z",
    transform: "translate(-404.14 -231.596)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144",
    transform: "translate(229.64 18.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3595",
    "data-name": "Path 3595",
    d: "M408.668,257.7a4.525,4.525,0,0,1-3.7-1.232l-1.232-1.232c-3.7-1.232-3.7-6.16-2.464-8.624l11.087-18.479,2.464-1.232c1.232,0,3.7,0,4.928,1.232l3.7,2.464,1.232,2.464c0,1.232,0,3.7-1.232,4.928l-11.088,18.479L409.9,257.7Z",
    transform: "translate(-400.54 -226.9)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(0 156.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(269.799 62.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3596",
    "data-name": "Path 3596",
    d: "M441.991,277.14a4.525,4.525,0,0,1-3.7-1.232L405.032,256.2l-1.232-4.928,2.464-4.928c1.232-3.7,6.16-3.7,8.624-2.464l30.8,18.479c3.7,1.232,3.7,6.16,2.464,8.624l-1.232,1.232C446.919,275.908,444.455,277.14,441.991,277.14Z",
    transform: "translate(-403.8 -243.14)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146",
    transform: "translate(304.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3597",
    "data-name": "Path 3597",
    d: "M431.239,252.883H412.76a5.82,5.82,0,0,1-6.16-6.16V244.26a5.82,5.82,0,0,1,6.16-6.16h18.48a5.82,5.82,0,0,1,6.16,6.16v2.464C438.631,250.419,434.935,252.883,431.239,252.883Z",
    transform: "translate(-406.6 -238.1)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147",
    transform: "translate(0 4.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3598",
    "data-name": "Path 3598",
    d: "M406.539,253.283H388.06a5.819,5.819,0,0,1-6.16-6.16V244.66a5.82,5.82,0,0,1,6.16-6.16h18.48a5.82,5.82,0,0,1,6.16,6.16v2.464C413.931,250.82,410.235,253.283,406.539,253.283Z",
    transform: "translate(-381.9 -238.5)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148",
    transform: "translate(21.438 71.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3599",
    "data-name": "Path 3599",
    d: "M391.769,273.513a6.775,6.775,0,0,1-6.16-3.7l-1.232-1.232c-1.232-3.7-1.232-7.392,2.464-8.624l25.871-14.783c3.7-2.464,7.392-1.232,8.624,2.464l2.464,3.7v3.7a3.934,3.934,0,0,1-3.7,3.7l-25.871,14.783C394.233,272.281,393,273.513,391.769,273.513Z",
    transform: "translate(-383.64 -243.896)",
    fill: "#91b4de"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    transform: "translate(0 75.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(161.387 208.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3600",
    "data-name": "Path 3600",
    d: "M403.624,298.91H401.16a5.82,5.82,0,0,1-6.16-6.16V254.56a5.82,5.82,0,0,1,6.16-6.16h2.464a5.82,5.82,0,0,1,6.16,6.16v38.191C411.015,296.446,407.32,298.91,403.624,298.91Z",
    transform: "translate(-395 -248.4)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    transform: "translate(232.104 206.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3601",
    "data-name": "Path 3601",
    d: "M417.492,278.544a6.775,6.775,0,0,1-6.16-3.7l-9.855-16.016c-1.232-3.7-1.232-7.392,2.464-8.623l1.232-1.232c3.7-1.232,7.392-1.232,8.624,2.464l9.855,16.015c1.232,3.7,1.232,7.392-2.464,8.624l-1.232,1.232C419.956,278.544,418.724,278.544,417.492,278.544Z",
    transform: "translate(-400.74 -248.24)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153",
    transform: "translate(269.799 144.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3602",
    "data-name": "Path 3602",
    d: "M441.991,276.463a4.526,4.526,0,0,1-3.7-1.232L405.032,255.52l-1.232-2.464c0-1.232,0-3.7,1.232-4.928l2.464-3.7,2.464-1.232c1.232,0,3.7,0,4.927,1.232l30.8,18.479a6.5,6.5,0,0,1,2.464,8.624l-1.232,1.232A6.6,6.6,0,0,1,441.991,276.463Z",
    transform: "translate(-403.8 -243.2)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154",
    transform: "translate(20.943 150.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3603",
    "data-name": "Path 3603",
    d: "M392.224,274.545a6.775,6.775,0,0,1-6.16-3.7l-2.464-3.7v-3.7a3.933,3.933,0,0,1,3.7-3.7l25.871-14.783c3.7-2.464,7.392-1.232,8.624,2.464l1.232,1.232c1.232,3.7,1.232,7.392-2.464,8.623l-25.871,14.783C393.456,274.545,393.456,274.545,392.224,274.545Z",
    transform: "translate(-383.6 -243.696)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155",
    transform: "translate(80.573 209.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3604",
    "data-name": "Path 3604",
    d: "M396.568,279.3l-4.927-2.464c-3.7-1.232-3.7-6.16-2.464-8.624l11.087-18.479,2.464-1.232c1.232,0,3.7,0,4.928,1.232l3.7,2.464,1.232,4.928-1.232,2.464-11.088,18.479Z",
    transform: "translate(-388.44 -248.5)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156",
    transform: "translate(19.711 4.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3605",
    "data-name": "Path 3605",
    d: "M421.691,265.84a4.524,4.524,0,0,1-3.7-1.232L384.732,244.9l-1.232-4.928,2.464-4.928c1.232-3.7,6.16-3.7,8.624-2.464l33.263,19.711,1.232,4.928-2.464,4.928C425.387,264.608,424.154,265.84,421.691,265.84Z",
    transform: "translate(-383.5 -231.84)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157",
    transform: "translate(0 86.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    "data-name": "Path 3606",
    d: "M406.539,253.283H388.06a5.819,5.819,0,0,1-6.16-6.16V244.66a5.82,5.82,0,0,1,6.16-6.16h18.48a5.82,5.82,0,0,1,6.16,6.16v2.464C413.931,250.82,410.235,253.283,406.539,253.283Z",
    transform: "translate(-381.9 -238.5)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158",
    transform: "translate(304.294 81.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3607",
    "data-name": "Path 3607",
    d: "M431.239,252.883H412.76a5.82,5.82,0,0,1-6.16-6.16V244.26a5.82,5.82,0,0,1,6.16-6.16h18.48a5.82,5.82,0,0,1,6.16,6.16v2.464C438.631,250.419,434.935,252.883,431.239,252.883Z",
    transform: "translate(-406.6 -238.1)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159",
    transform: "translate(272.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3608",
    "data-name": "Path 3608",
    d: "M413.855,262.3h-3.7a3.934,3.934,0,0,1-3.7-3.7l-2.464-3.7v-3.7a3.934,3.934,0,0,1,3.7-3.7L434.8,231.5h3.7a3.934,3.934,0,0,1,3.7,3.7l2.464,3.7v3.7a3.934,3.934,0,0,1-3.7,3.7Z",
    transform: "translate(-404 -231.5)",
    fill: "#91b4de"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185",
    transform: "translate(3434.296 1533.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(76.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3609",
    "data-name": "Path 3609",
    d: "M339.8,183.971h0q-3.7,0-3.7-3.7V161.8a3.934,3.934,0,0,1,3.7-3.7h1.232a3.934,3.934,0,0,1,3.7,3.7v18.479C343.492,182.739,342.26,183.971,339.8,183.971Z",
    transform: "translate(-336.1 -158.1)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164",
    transform: "translate(38.191 13.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3610",
    "data-name": "Path 3610",
    d: "M340.391,173.22c-1.232,0-2.464,0-2.464-1.232L333,163.365V160.9l2.464-1.232c1.232-1.232,3.7,0,4.927,1.232l4.928,7.392c1.232,1.232,0,3.7-1.232,4.928h-3.7Z",
    transform: "translate(-333 -159.159)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165",
    transform: "translate(10.577 40.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3611",
    "data-name": "Path 3611",
    d: "M348.516,177.884h-1.232L332.5,169.261c-1.232-1.232-2.464-2.464-1.232-4.928V163.1c1.232-1.232,2.464-2.464,4.928-1.232l14.784,8.624c1.232,1.232,2.464,2.464,1.232,4.928l-1.232,1.232-2.464,1.232Z",
    transform: "translate(-330.758 -161.358)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    transform: "translate(132.541 37.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3612",
    "data-name": "Path 3612",
    d: "M343.633,176.452c-1.232,0-2.464,0-2.464-1.232v-1.232c-1.232-1.232,0-3.7,1.232-4.928l12.319-7.392c1.232-1.232,3.7,0,4.928,1.232l1.232,1.232v1.232c0,1.232-1.232,1.232-1.232,2.464l-12.32,7.392A9.534,9.534,0,0,1,343.633,176.452Z",
    transform: "translate(-340.659 -161.158)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167",
    transform: "translate(110.366 12.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3613",
    "data-name": "Path 3613",
    d: "M343.065,172.651H340.6c-1.232-1.232-2.464-2.464-1.232-4.928L344.3,159.1h3.7l1.232,1.232v3.7l-4.928,8.624Z",
    transform: "translate(-338.858 -159.1)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172",
    transform: "translate(0 75.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168",
    transform: "translate(129.356 32.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3614",
    "data-name": "Path 3614",
    d: "M358.88,182.152h-1.232l-16.015-8.624-1.232-2.464,1.232-2.464c1.232-1.232,2.464-2.464,4.928-1.232l14.784,8.623c1.232,1.232,2.464,2.464,1.232,4.928v1.232C361.343,180.92,360.111,182.152,358.88,182.152Z",
    transform: "translate(-340.4 -166.859)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169",
    transform: "translate(145.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3615",
    "data-name": "Path 3615",
    d: "M354.02,172.824H345.4a3.934,3.934,0,0,1-3.7-3.7V167.9a3.934,3.934,0,0,1,3.7-3.7h8.624a3.933,3.933,0,0,1,3.7,3.7v1.232Q357.715,172.824,354.02,172.824Z",
    transform: "translate(-341.7 -164.2)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170",
    transform: "translate(0 2.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3616",
    "data-name": "Path 3616",
    d: "M342.219,173.024H333.6a3.934,3.934,0,0,1-3.7-3.7V168.1a3.934,3.934,0,0,1,3.7-3.7h8.624a3.933,3.933,0,0,1,3.7,3.7v1.232Q345.916,173.024,342.219,173.024Z",
    transform: "translate(-329.9 -164.4)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171",
    transform: "translate(11.809 33.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3617",
    "data-name": "Path 3617",
    d: "M333.833,182.253c-1.232,0-2.464,0-2.464-1.232v-1.232c-1.232-1.232,0-3.7,1.232-4.928l12.319-7.392c1.232-1.232,3.7,0,4.928,1.232l1.232,1.232v1.232c0,1.232-1.232,1.232-1.232,2.464l-12.319,7.392A9.536,9.536,0,0,1,333.833,182.253Z",
    transform: "translate(-330.858 -166.959)",
    fill: "#91b4de"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(0 39.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174",
    transform: "translate(78.846 96.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3618",
    "data-name": "Path 3618",
    d: "M340,194.971h0q-3.7,0-3.7-3.7V172.8a3.934,3.934,0,0,1,3.7-3.7h1.232a3.934,3.934,0,0,1,3.7,3.7v18.479C342.46,193.739,341.228,194.971,340,194.971Z",
    transform: "translate(-336.3 -169.1)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(111.598 98.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3619",
    "data-name": "Path 3619",
    d: "M346.861,183.321c-1.232,0-2.464,0-2.464-1.232l-4.928-7.392c-1.232-1.232,0-3.7,1.232-4.928h1.232c1.232-1.232,3.7,0,4.928,1.232l4.928,7.392c1.232,1.232,0,3.7-1.232,4.928h-3.7Z",
    transform: "translate(-338.958 -169.259)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    transform: "translate(130.588 70.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    "data-name": "Path 3620",
    d: "M357.747,180.552h-1.232L340.5,171.928v-3.7L341.732,167h3.7l14.784,8.624c1.232,1.232,2.464,2.464,1.232,4.928v1.232C360.211,179.319,358.979,180.552,357.747,180.552Z",
    transform: "translate(-340.5 -167)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(11.088 70.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    "data-name": "Path 3621",
    d: "M334.5,181.121c-1.232,0-2.465,0-2.465-1.232l-1.232-1.232v-1.232c0-1.232,1.232-1.232,1.232-2.464l12.32-7.392c1.232-1.232,3.7,0,4.928,1.232v1.232c1.232,1.232,0,3.7-1.232,4.928l-12.32,7.392A1.206,1.206,0,0,0,334.5,181.121Z",
    transform: "translate(-330.8 -167.059)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    transform: "translate(38.912 98.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    "data-name": "Path 3622",
    d: "M337.265,184.083l-2.464-1.232c-1.232-1.232-2.464-2.464-1.232-4.928L338.5,169.3h3.7l1.232,1.232L344.657,173v1.232l-4.928,8.624Z",
    transform: "translate(-333.058 -169.3)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    transform: "translate(9.856 1.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    "data-name": "Path 3623",
    d: "M349.179,176.752h-1.232l-16.015-8.624-1.232-2.464,1.232-2.464c1.232-1.232,2.464-2.464,4.927-1.232l16.015,8.624,1.232,2.464-1.232,2.464C351.643,175.52,350.411,176.752,349.179,176.752Z",
    transform: "translate(-330.7 -161.459)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180",
    transform: "translate(0 38.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3624",
    "data-name": "Path 3624",
    d: "M342.219,173.024H333.6a3.934,3.934,0,0,1-3.7-3.7V168.1a3.934,3.934,0,0,1,3.7-3.7h8.624a3.933,3.933,0,0,1,3.7,3.7v1.232Q345.916,173.024,342.219,173.024Z",
    transform: "translate(-329.9 -164.4)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(145.371 35.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    "data-name": "Path 3625",
    d: "M354.02,172.824H345.4a3.934,3.934,0,0,1-3.7-3.7V167.9a3.934,3.934,0,0,1,3.7-3.7h8.624a3.933,3.933,0,0,1,3.7,3.7v1.232Q357.715,172.824,354.02,172.824Z",
    transform: "translate(-341.7 -164.2)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    transform: "translate(130.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    "data-name": "Path 3626",
    d: "M345.428,174.852H344.2c-1.232,0-1.232-1.232-2.464-1.232l-1.232-1.232v-1.232c0-1.232,1.232-1.232,1.232-2.464l13.551-7.392h1.232c1.232,0,1.232,1.232,2.464,1.232l1.232,1.232V165c0,1.232-1.232,1.232-1.232,2.464Z",
    transform: "translate(-340.5 -161.3)",
    fill: "#91b4de"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    "data-name": "Group 1208",
    transform: "translate(4010.853 1663.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186",
    transform: "translate(118.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    "data-name": "Path 3627",
    d: "M392.46,206.791h-1.232a5.3,5.3,0,0,1-4.928-4.928V173.528a5.3,5.3,0,0,1,4.928-4.928h1.232a5.3,5.3,0,0,1,4.928,4.928v28.335C397.388,205.559,394.924,206.791,392.46,206.791Z",
    transform: "translate(-386.3 -168.6)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(59.134 16.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3628",
    "data-name": "Path 3628",
    d: "M392.587,192.644c-1.232,0-3.7-1.232-3.7-2.464L381.5,176.629l1.232-3.7,3.7-2.464a5.417,5.417,0,0,1,6.16,1.232l7.392,12.319c1.232,2.464,0,4.928-1.232,7.392l-1.232,1.232Z",
    transform: "translate(-381.5 -169.959)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    transform: "translate(14.672 60.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3629",
    "data-name": "Path 3629",
    d: "M406.337,199.473c-1.232,0-1.232,0-2.464-1.232L380.466,184.69a4.643,4.643,0,0,1-1.232-7.392l1.232-1.232c1.232-2.464,4.928-3.7,6.16-1.232l23.407,13.552a4.643,4.643,0,0,1,1.232,7.392l-1.232,2.464-2.464,1.232Z",
    transform: "translate(-377.891 -173.491)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(203.995 57.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3630",
    "data-name": "Path 3630",
    d: "M398.7,195.944c-1.232,0-3.7-1.232-3.7-2.464l-1.232-1.232c-1.232-2.464,0-4.928,1.232-7.392l19.711-11.087c2.464-1.232,4.928,0,7.392,1.232l1.232,2.464v2.464a2.649,2.649,0,0,1-2.464,2.464L401.161,193.48C401.161,195.944,399.928,195.944,398.7,195.944Z",
    transform: "translate(-393.259 -173.259)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(171.131 14.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3631",
    "data-name": "Path 3631",
    d: "M396.862,193.207c-1.232,0-1.232,0-2.464-1.232l-1.232-1.232c-2.464-1.232-3.7-4.928-1.232-6.16l7.391-13.551,2.464-1.232h3.7l2.465,1.232,1.232,2.464v3.7l-7.392,13.552-2.464,1.232C398.094,193.207,398.094,193.207,396.862,193.207Z",
    transform: "translate(-390.591 -169.8)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195",
    transform: "translate(0 118.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(200.809 45.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3632",
    "data-name": "Path 3632",
    d: "M421.335,207.873c-1.232,0-1.232,0-2.464-1.232l-24.639-14.783-1.232-3.7,1.232-3.7c1.232-2.464,4.927-3.7,6.16-1.232L423.8,196.785c2.464,1.232,3.7,4.928,1.232,6.16l-1.232,1.232C425.031,206.641,423.8,207.873,421.335,207.873Z",
    transform: "translate(-393 -181.891)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192",
    transform: "translate(226.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    "data-name": "Path 3633",
    d: "M413.579,189.287H400.028a5.3,5.3,0,0,1-4.928-4.928v-1.232a5.3,5.3,0,0,1,4.928-4.928h13.551a5.3,5.3,0,0,1,4.928,4.928v1.232A5.3,5.3,0,0,1,413.579,189.287Z",
    transform: "translate(-395.1 -178.2)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(0 3.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    "data-name": "Path 3634",
    d: "M395.18,189.588H381.628a5.3,5.3,0,0,1-4.928-4.928v-1.232a5.3,5.3,0,0,1,4.928-4.928H395.18a5.3,5.3,0,0,1,4.927,4.928v1.232A5.3,5.3,0,0,1,395.18,189.588Z",
    transform: "translate(-376.7 -178.5)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(15.505 51.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    "data-name": "Path 3635",
    d: "M384.629,205.044a9.341,9.341,0,0,1-4.928-2.464l-1.232-1.232c-1.232-2.464,0-4.928,1.232-7.392l19.711-11.087c2.464-1.232,4.928,0,7.392,1.232l1.232,2.464v2.464a2.649,2.649,0,0,1-2.464,2.464L385.86,202.58C385.86,205.044,385.86,205.044,384.629,205.044Z",
    transform: "translate(-377.959 -182.359)",
    fill: "#91b4de"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    "data-name": "Group 1207",
    transform: "translate(0 57.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    transform: "translate(120.732 153.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3636",
    "data-name": "Path 3636",
    d: "M392.66,223.991h-1.232a5.3,5.3,0,0,1-4.928-4.928V190.728a5.3,5.3,0,0,1,4.928-4.928h1.232a5.3,5.3,0,0,1,4.928,4.928v28.335A5.3,5.3,0,0,1,392.66,223.991Z",
    transform: "translate(-386.5 -185.8)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198",
    transform: "translate(174.428 152.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3637",
    "data-name": "Path 3637",
    d: "M402.456,209.576c-1.232,0-3.7-1.232-3.7-2.464l-7.391-12.319c-1.232-2.464,0-4.928,1.232-7.392l1.232-1.232c2.464-1.232,4.927,0,7.392,1.232l7.391,12.32c1.232,2.464,0,4.928-1.232,7.392l-1.232,1.232A5.4,5.4,0,0,0,402.456,209.576Z",
    transform: "translate(-390.858 -185.659)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199",
    transform: "translate(200.809 104.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3638",
    "data-name": "Path 3638",
    d: "M421.335,207.671c-1.232,0-1.232,0-2.464-1.232l-24.639-14.783L393,189.192v-3.7l1.232-2.464L396.7,181.8h3.7L423.8,195.352a4.643,4.643,0,0,1,1.232,7.392l-1.232,1.232C425.031,207.671,422.567,207.671,421.335,207.671Z",
    transform: "translate(-393 -181.8)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    transform: "translate(17.247 112.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    "data-name": "Path 3639",
    d: "M383.028,203.912c-1.232,0-3.7-1.232-3.7-2.464l-1.232-2.464V196.52a2.65,2.65,0,0,1,2.464-2.464l19.711-11.087c2.464-1.232,4.928,0,7.392,1.232l1.232,1.232c1.232,2.464,0,4.928-1.232,7.392l-19.711,11.088Z",
    transform: "translate(-378.1 -182.459)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201",
    transform: "translate(60.255 153.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    "data-name": "Path 3640",
    d: "M387.862,209.207l-3.7-1.232a4.643,4.643,0,0,1-1.232-7.392l7.391-13.552,2.464-1.232h3.7l2.464,1.232,1.232,3.7-1.232,2.464-7.392,13.552Z",
    transform: "translate(-381.591 -185.8)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202",
    transform: "translate(14.783 1.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    "data-name": "Path 3641",
    d: "M406.235,199.373c-1.232,0-1.232,0-2.464-1.232l-24.639-14.784-1.232-3.7,1.232-3.7c1.232-2.464,4.927-3.7,6.16-1.232l24.639,14.783,1.232,3.7-1.232,3.7C409.931,199.373,407.467,199.373,406.235,199.373Z",
    transform: "translate(-377.9 -173.391)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203",
    transform: "translate(0 64.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3642",
    "data-name": "Path 3642",
    d: "M395.18,189.588H381.628a5.3,5.3,0,0,1-4.928-4.928v-1.232a5.3,5.3,0,0,1,4.928-4.928H395.18a5.3,5.3,0,0,1,4.927,4.928v1.232A5.3,5.3,0,0,1,395.18,189.588Z",
    transform: "translate(-376.7 -178.5)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204",
    transform: "translate(226.68 60.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3643",
    "data-name": "Path 3643",
    d: "M413.579,189.287H400.028a5.3,5.3,0,0,1-4.928-4.928v-1.232a5.3,5.3,0,0,1,4.928-4.928h13.551a5.3,5.3,0,0,1,4.928,4.928v1.232A5.3,5.3,0,0,1,413.579,189.287Z",
    transform: "translate(-395.1 -178.2)",
    fill: "#91b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205",
    transform: "translate(204.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3644",
    "data-name": "Path 3644",
    d: "M399.46,195.475H397a2.65,2.65,0,0,1-2.464-2.464l-1.232-2.464v-2.464a2.65,2.65,0,0,1,2.464-2.464L416.707,173.3h2.464a2.65,2.65,0,0,1,2.464,2.464l1.232,2.464v2.464a2.65,2.65,0,0,1-2.464,2.464Z",
    transform: "translate(-393.3 -173.3)",
    fill: "#91b4de"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    "data-name": "Group 1212",
    transform: "translate(1451.989 1373.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    "data-name": "Group 1209",
    transform: "translate(28.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3645",
    "data-name": "Path 3645",
    d: "M399.212,3399.934H1660.738c118.268,0,213.129-104.717,213.129-234.072l-12.32-2786.69c0-129.356-97.324-234.072-214.361-234.072H384.429C266.161,145.1,171.3,249.816,171.3,379.172l12.319,2786.69C184.851,3295.218,280.944,3399.934,399.212,3399.934Z",
    transform: "translate(-171.3 -145.1)",
    fill: "#000543"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1210",
    "data-name": "Group 1210",
    transform: "translate(2.549 512.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3646",
    "data-name": "Path 3646",
    d: "M195.071,186.7H196.3l1.232,218.057H196.3a26.022,26.022,0,0,1-25.871-25.871L169.2,212.571C169.2,199.019,181.52,186.7,195.071,186.7Z",
    transform: "translate(-169.2 -186.7)",
    fill: "#000543"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211",
    transform: "translate(0 749.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3647",
    "data-name": "Path 3647",
    d: "M194.949,205.9a11.107,11.107,0,0,1,6.16,1.232l1.232,216.825c-2.464,0-3.7,1.232-6.16,1.232a26.022,26.022,0,0,1-25.871-25.871L169.078,233C167.846,218.22,180.166,205.9,194.949,205.9Z",
    transform: "translate(-168.993 -205.9)",
    fill: "#000543"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3648",
    "data-name": "Path 3648",
    d: "M1777.046,1767.593V1706l-1.232-204.505-2.464-448.433-2.464-439.809-1.232-279.655c0-102.253-75.149-184.794-167.547-184.794H341.814c-92.4,0-166.315,82.541-166.315,184.794V437.078l1.232,417.634,1.232,197.114v68.99l2.464,581.484v61.6l2.464,567.933v38.19l1.232,327.7v38.191l1.232,321.542c0,6.16,0,12.319,1.232,17.247a190.571,190.571,0,0,0,7.392,38.191c22.175,73.917,85.005,128.123,160.155,128.123H1615.66c23.407,0,45.583-4.927,65.294-14.783,36.959-17.248,67.758-49.278,85.005-88.7,11.088-24.639,16.016-51.743,16.016-80.077Z",
    transform: "translate(-95.337 -103.217)",
    fill: "#6d72a0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220",
    transform: "translate(1673.763 425.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3649",
    "data-name": "Path 3649",
    d: "M207.3,171.9c0,30.8,16.015,72.685,40.655,99.789,27.1-9.856,60.366-4.928,86.237,13.552l12.32,8.624s23.407,16.015,52.974,36.959c2.464-1.232,3.7,1.232,4.928,3.7,12.319,8.624,24.639,17.247,35.727,25.871l211.9,147.835,13.551,9.856c40.655,28.335,50.51,80.077,22.175,114.572-28.335,35.727-62.83,32.031-103.484,3.7l-93.629-59.134-4.928,7.392,59.134,41.887c34.495,23.407,43.119,66.526,18.479,97.325-23.407,29.567-55.438,22.175-89.933-2.464l-59.134-36.959-3.7,6.16,33.263,23.407c28.335,19.711,35.727,55.438,16.015,81.309-19.711,24.639-45.582,20.943-73.918,1.232L352.671,775.56c-6.16,17.247,2.464,38.191,19.711,49.279l34.495,20.943c19.711,12.32,40.655,20.943,61.6,24.639,112.108-166.315,248.856-177.4,248.856-177.4l1.232-2.464c0-17.247,1.232-35.727,1.232-55.438L743.2,455.251l7.392-56.67-33.263-24.639v-1.232L583.048,261.833c-19.711-8.624-43.119-17.247-65.294-25.871-1.232,0-2.464-1.232-3.7-1.232l-78.845-34.5-3.7,7.392c-20.943,36.959-70.222,50.51-110.876,30.8l-12.32-6.16-77.613-35.727C224.547,190.379,214.692,181.756,207.3,171.9Zm383.139,94.861h0l-2.464-2.464Z",
    transform: "translate(42.851 1106.873)",
    fill: "#ef6c5e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1219",
    "data-name": "Group 1219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1213",
    "data-name": "Group 1213",
    transform: "translate(469.44 1437.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3650",
    "data-name": "Path 3650",
    d: "M308.914,238.075c29.567,0,56.67-8.623,80.077-22.175,1.232,3.7,2.464,7.392,2.464,11.087,0,29.567-35.727,52.974-80.077,52.974S231.3,256.555,231.3,226.987c0-2.464,0-6.16,1.232-8.624a156.419,156.419,0,0,0,76.381,19.711Z",
    transform: "translate(-154.919 167.239)",
    fill: "#687bc1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    width: 306.758,
    height: 157.691,
    fill: "#404f9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    "data-name": "Rectangle 768",
    width: 306.758,
    height: 46.814,
    transform: "translate(0 173.706)",
    fill: "#404f9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3651",
    "data-name": "Path 3651",
    d: "M225.1,218.783V204H531.858v14.783a124.123,124.123,0,0,1-3.7,30.8h-300.6C226.332,239.727,225.1,229.871,225.1,218.783Z",
    transform: "translate(-225.1 32.536)",
    fill: "#404f9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3652",
    "data-name": "Path 3652",
    d: "M517.774,210.132c-11.087,35.727-35.727,65.294-66.526,83.773-23.407,14.784-50.51,22.175-80.077,22.175a155.24,155.24,0,0,1-75.15-19.711A147.078,147.078,0,0,1,225.8,208.9H517.774Z",
    transform: "translate(-217.176 88.002)",
    fill: "#404f9b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    "data-name": "Group 1214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    d: "M550.486,123.538c163.851-73.918,353.572-73.918,517.423,0,197.114,87.469,349.876,272.263,363.428,553.149,0,7.392,1.232,16.016,1.232,23.407,3.7,208.2-154,399.155-279.655,545.758a694.063,694.063,0,0,0-129.356,226.68l-11.088,29.567c-33.263,73.918-24.639,119.5-105.949,119.5H713.1c-81.309,0-72.685-45.582-105.949-119.5-3.7-9.856-8.624-19.711-11.087-29.567-28.335-82.541-71.454-160.155-129.356-226.68-125.66-146.6-283.35-336.325-279.655-545.758,0-7.392,0-16.016,1.232-23.407C200.61,395.8,353.373,211.007,550.486,123.538Z",
    transform: "translate(-186.995 -68.1)",
    fill: "#ffd878"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215",
    transform: "translate(353.465 724.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    "data-name": "Path 3654",
    d: "M474.568,261.009h2.464c4.928,0,9.856,0,13.552-1.232,33.263-4.928,55.438-32.031,78.845-59.134,20.943-24.639,40.655-46.814,64.062-50.51,14.783-2.464,33.263,2.464,49.278,16.016,16.015,12.32,30.8,29.567,44.35,45.582a11.358,11.358,0,1,0,17.247-14.783C729.583,179.7,714.8,161.22,696.32,147.669c-16.015-11.088-39.422-24.639-67.758-19.711-33.263,4.928-55.438,32.031-78.845,59.134-20.943,24.639-40.655,46.814-64.062,50.51-3.7,0-6.16,1.232-9.856,0H464.712c-24.639-3.7-44.351-27.1-64.062-50.51-22.175-25.871-45.582-52.974-78.845-59.134a66.992,66.992,0,0,0-22.175,0c-33.263,4.928-55.438,32.031-78.845,59.134l-2.464,2.464c-3.7,4.928-3.7,12.32,1.232,16.016s12.32,3.7,16.015-1.232l2.464-2.464c20.943-24.639,40.655-46.814,64.062-50.51a30.027,30.027,0,0,1,14.783,0c24.639,3.7,44.351,27.1,64.062,50.51,22.175,25.871,45.582,52.974,78.845,59.134Z",
    transform: "translate(-215.686 -126.915)",
    fill: "#fcb24f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216",
    transform: "translate(687.603 801.536)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    "data-name": "Rectangle 769",
    width: 772.438,
    height: 7.392,
    transform: "translate(0 750.424) rotate(-76.29)",
    fill: "#fcb24f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217",
    transform: "translate(363.54 802.129)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    "data-name": "Rectangle 770",
    width: 7.392,
    height: 772.438,
    transform: "translate(0 1.749) rotate(-13.686)",
    fill: "#fcb24f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218",
    transform: "translate(609.883 847.587)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    "data-name": "Rectangle 771",
    width: 7.392,
    height: 705.912,
    fill: "#fcb24f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    "data-name": "Path 3655",
    d: "M246.764,170.5h0Z",
    transform: "translate(461.676 1091.026)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    "data-name": "Path 3656",
    d: "M310.944,210.606l101.021,48.046c8.624,4.928,16.015,9.856,22.175,16.015-25.871-60.366,3.7-131.819,39.423-113.34l167.546,88.7,13.552,7.392c13.552,4.928,24.639,12.32,34.495,20.943a79.093,79.093,0,0,1,16.015,12.319l198.345,150.3c39.423,29.567,46.814,83.773,46.814,87.469l67.758,299.366,6.16,52.974-38.191,17.247L841.918,1103.776l-60.366-38.191c1.232-1.232,2.464-1.232,4.928-2.464-22.175-23.407-52.974-81.309-51.742-220.521,0-17.247,1.232-35.727,1.232-55.438L759.377,607.3l7.392-56.67-33.263-24.639v-1.232L599.223,413.879l-32.031-25.871h-4.928l1.232-2.464-80.077-55.438a127.217,127.217,0,0,1-30.8-25.871,65.278,65.278,0,0,1-2.464,48.046l-3.7,7.392c-20.943,36.959-70.222,50.51-110.876,30.8l-12.32-6.16-77.613-35.727c-12.319-4.928-20.943-13.552-28.335-24.639-12.319-18.479-14.783-43.119-4.928-66.526l4.928-12.319C234.563,210.606,276.449,193.358,310.944,210.606Z",
    transform: "translate(31.604 953.595)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3657",
    "data-name": "Path 3657",
    d: "M422.566,197.863l12.32,8.624s23.407,16.015,52.974,36.959c1.232,1.232,3.7,2.464,4.928,3.7,1.232,2.464,3.7,4.928,6.16,3.7l30.8,20.943c0,6.16,1.232,35.727-12.32,65.294l-20.943,28.335c-13.552,13.552-33.263,25.871-60.366,32.031l22.175,14.784c-11.088-6.16-41.887-25.871-41.887-25.871L481.7,431.935c0,2.464,4.928,29.567-12.32,57.9l-7.392,11.087c-11.088,13.552-27.1,27.1-52.974,36.959l-14.783-8.624,13.552,9.856h-1.232l6.16,3.7,14.783,9.856c1.232,12.32,2.464,57.9-65.294,85.005l-56.67-35.727-78.845-49.278c-28.335-19.711-35.727-55.438-16.015-81.309,13.552-16.015,34.495-23.407,56.67-20.943-34.495-23.407-43.119-67.758-18.479-97.325,18.479-23.407,50.51-30.8,78.845-23.407l-7.392-4.928c-40.655-28.335-50.51-80.077-22.175-115.8A78.049,78.049,0,0,1,335.1,183.08C363.432,175.688,395.463,179.384,422.566,197.863Z",
    transform: "translate(-44.291 1193.018)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3658",
    "data-name": "Path 3658",
    d: "M264.97,551.76,208.3,516.033c25.871,81.309,86.237,153.995,172.474,199.577L723.259,915.188,819.352,778.44s-56.67-39.423-55.438-40.655c-22.175-23.407-52.974-81.309-51.742-220.52l-1.232,2.464s-136.747,9.856-248.856,177.4c-20.943-4.928-41.887-12.319-61.6-24.639l-34.495-20.943c-18.479-11.088-25.871-32.031-19.711-49.278l33.263,20.943c28.335,19.711,54.206,23.407,73.918-1.232s12.319-61.6-16.016-81.309l-33.263-23.407,3.7-6.16,59.134,36.959c34.5,23.407,66.526,32.031,89.933,2.464s14.783-73.918-18.479-97.325l-59.134-41.887,4.928-7.392,93.629,59.134c40.655,28.335,75.149,30.8,103.484-3.7,28.335-35.727,18.479-87.469-22.175-114.572l-13.552-9.856L433.748,187.1c0,6.16,1.232,35.727-12.32,65.294l-20.943,28.335C386.934,294.28,367.223,306.6,340.12,312.76l22.175,14.783a15.247,15.247,0,0,1,3.7,2.464l-45.582-28.335L385.7,347.254c0,2.464,4.928,29.567-12.319,57.9l-7.392,11.087c-11.087,13.552-27.1,27.1-52.974,36.959l-14.783-8.624,13.552,9.856h-1.232l6.16,3.7,14.783,9.856c0,11.088,1.232,57.9-66.526,83.773Z",
    transform: "translate(54.171 1278.931)",
    fill: "#f97a69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3659",
    "data-name": "Path 3659",
    d: "M898.949,298.579l131.82,1879.969L226.3,2177.315,278.042,334.306c0-32.031,19.711-61.6,51.742-62.83l506.335-28.335C868.15,241.909,896.485,266.548,898.949,298.579Z",
    transform: "translate(257.923 1912.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3660",
    "data-name": "Path 3660",
    d: "M237.064,514.73C546.285,578.792,697.817,212.9,697.817,212.9l40.654,373.283L234.6,614.518Z",
    transform: "translate(351.876 1570.976)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    "data-name": "Path 3661",
    d: "M446.5,226.7S375.043,331.416,237.064,358.519L234.6,458.308l353.572-32.031Z",
    transform: "translate(351.876 1727.186)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3662",
    "data-name": "Path 3662",
    d: "M433.245,261.659S452.957,309.7,553.977,317.1c12.319,1.232,11.087,19.711-1.232,20.943L234.9,381.159,403.678,224.7Z",
    transform: "translate(355.272 1704.547)",
    fill: "#f97a69"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    "data-name": "Group 1224",
    transform: "translate(2173.952 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221",
    transform: "translate(88.681 149.184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_772",
    "data-name": "Rectangle 772",
    width: 676.345,
    height: 315.381,
    transform: "translate(160.182 0) rotate(30.525)",
    fill: "#000544"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    "data-name": "Group 1222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3663",
    "data-name": "Path 3663",
    d: "M1326.553,693.976,231.342,48.429a8.031,8.031,0,1,1,8.624-13.552L1335.177,679.192a8.025,8.025,0,0,1,2.464,11.088C1335.177,695.208,1330.249,696.44,1326.553,693.976Z",
    transform: "translate(-227.596 -33.596)",
    fill: "#000544"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1223",
    "data-name": "Group 1223",
    transform: "translate(846.488 633.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3664",
    "data-name": "Path 3664",
    d: "M303.616,388.062,521.673,85,361.518,422.557c-7.392,17.247-28.335,24.639-45.583,16.015-17.247-7.392-24.639-28.335-16.015-45.582A17,17,0,0,0,303.616,388.062Z",
    transform: "translate(-296.307 -85)",
    fill: "#000544"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    "data-name": "Group 1236",
    transform: "translate(2736.449 2536.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3665",
    "data-name": "Path 3665",
    d: "M462.468,258.571c-14.784,13.552-28.335,30.8-46.814,38.191-16.015,7.392-33.263,7.392-49.278,13.552s-32.031,20.943-28.335,39.423c1.232,8.624,7.392,14.783,8.624,23.407,4.928,23.407-20.943,38.191-36.958,55.438-17.247,18.479-24.639,48.047-16.015,73.917,6.16,18.479,18.479,36.959,12.32,54.206-4.928,13.552-20.944,22.175-22.175,36.959-1.232,22.175,28.335,32.031,35.727,51.742,4.928,14.784-1.232,30.8-3.7,45.583-4.928,28.335,8.624,59.134,33.263,73.917,12.32,8.624,28.335,12.32,38.191,24.639,12.32,16.016,11.088,39.423,25.871,52.974,29.567,27.1,60.366-9.855,96.093-19.711,44.351-12.32,99.789,23.407,134.283-8.624,7.392-7.392,13.552-18.479,24.639-20.943s22.175,4.928,32.031,2.464c20.943-2.464,27.1-32.031,43.119-44.351,1.232-1.232,11.087-6.16,12.319-6.16C864.087,688.524,930.613,587.5,909.669,488.947c-16.015-81.309-88.7-140.443-182.33-163.85a4.526,4.526,0,0,0-1.232-3.7c-9.855-25.871-29.567-41.887-54.206-52.974-44.351-20.943-77.613,11.087-117.036,0-14.784-4.928-23.407-20.943-38.191-27.1C499.426,235.164,478.483,245.02,462.468,258.571Z",
    transform: "translate(-153.919 -239.448)",
    fill: "#895147"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235",
    transform: "translate(0 99.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1225",
    "data-name": "Group 1225",
    transform: "translate(1281.796 1833.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3666",
    "data-name": "Path 3666",
    d: "M513.368,424.651l-13.552-6.16c-54.206,30.8-89.933,12.32-108.412-7.392l-11.087,45.583c-1.232,3.7,2.464,7.391,8.624,7.391l110.876,1.232C530.616,466.538,539.239,435.739,513.368,424.651Z",
    transform: "translate(-345.822 -230.002)",
    fill: "#ff685a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    d: "M531.295,586.121,496.8,572.57,489.408,543,457.377,418.575,377.3,396.4l46.814,170.01c1.232,0-2.464,13.552-2.464,13.552C441.362,597.21,477.089,616.921,531.295,586.121Z",
    transform: "translate(-377.3 -396.4)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    "data-name": "Path 3668",
    d: "M591.736,424.251l-19.711-6.16c-75.149,32.031-123.2,12.319-149.067-7.392l-14.784,46.814c-1.232,3.7,3.7,8.624,11.088,8.624H572.024C613.911,467.37,627.462,435.34,591.736,424.251Z",
    transform: "translate(-29.962 -234.53)",
    fill: "#ff685a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3669",
    "data-name": "Path 3669",
    d: "M606.941,573.17l-71.454-22.175-2.464-7.392L496.065,419.175,404.9,397l52.974,166.314v2.464C483.745,585.489,533.023,606.433,606.941,573.17Z",
    transform: "translate(-64.879 -389.608)",
    fill: "#ff9985"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1226",
    "data-name": "Group 1226",
    transform: "translate(197.672 1454.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    "data-name": "Path 3670",
    d: "M302.852,992.667A13.672,13.672,0,0,1,289.3,979.116V379.152a13.552,13.552,0,1,1,27.1,0V979.116A13.672,13.672,0,0,1,302.852,992.667Z",
    transform: "translate(-289.3 -365.6)",
    fill: "#6d72a0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3671",
    "data-name": "Path 3671",
    d: "M0,0C14.783,55.438,28.335,104.717,40.654,146.6c22.175,76.382-66.526,125.66,16.016,125.66,236.536,0,416.4,0,556.845,1.232V0Z",
    transform: "translate(822.276 1355.791)",
    fill: "#6d9fa7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227",
    transform: "translate(838.291 1017.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3672",
    "data-name": "Path 3672",
    d: "M1404.48,1378.5c-6.16,0-11.087-3.7-13.552-9.855l-289.51-923.969C1085.4,392.93,1031.2,357.2,970.831,357.2H354.852a13.552,13.552,0,0,1,0-27.1H970.831c72.685,0,136.748,44.351,156.459,107.181l289.51,923.969a13.314,13.314,0,0,1-8.624,17.247Z",
    transform: "translate(-341.3 -330.1)",
    fill: "#6d72a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    transform: "translate(0 431.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3673",
    "data-name": "Path 3673",
    d: "M1250.847,982.353C1206.5,851.765,1159.682,675.6,1133.811,520.368c-8.624-50.51-20.943-101.021-34.494-150.3-14.784-51.742-57.9-87.469-107.181-87.469H277.6S447.61,885.027,472.249,982.352c32.031,126.892,24.639,268.567,126.892,271.031,19.711,0,183.562-19.711,205.737-19.711,67.758-4.927,171.242-2.464,219.288-8.624,44.351-6.16,91.165-16.015,121.964,14.784h27.1l-48.046-204.505H1277.95C1266.862,1020.543,1258.239,1002.064,1250.847,982.353Z",
    transform: "translate(-224.067 -282.6)",
    fill: "#6d9fa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3674",
    "data-name": "Path 3674",
    d: "M1300.035,1241.064c-34.495-30.8-86.237-38.191-136.748-32.031-52.974,6.16-170.01,11.087-246.392,16.015-23.407,0-163.85,9.855-186.026,9.855-114.572-2.464-130.588-43.119-166.314-170.01-23.407-81.309-131.82-569.165-167.547-730.551-6.16-29.567-33.263-51.742-64.062-51.742-35.727,0-64.062,30.8-59.134,66.526,25.871,215.593,108.412,888.242,135.515,997.886,18.479,76.382,76.382,130.588,144.139,130.588h624.6a145.151,145.151,0,0,0,85.005-27.1c75.15-54.206,88.7-102.252,65.294-167.546A109.876,109.876,0,0,0,1300.035,1241.064Z",
    transform: "translate(-273.255 -282.6)",
    fill: "#397d88"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3675",
    "data-name": "Path 3675",
    d: "M387.3,357.6V631.1c388.067,1.232,373.284-1.232,417.634-28.335,1.232,0,1.232-1.232,2.464-1.232C919.506,532.538,866.532,357.6,734.712,357.6H387.3Z",
    transform: "translate(1017.692 998.19)",
    fill: "#6d9fa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3676",
    "data-name": "Path 3676",
    d: "M319.4,347.3c2.464,1.232,4.928,1.232,6.16,2.464A51.866,51.866,0,0,1,319.4,347.3Z",
    transform: "translate(249.092 881.598)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3677",
    "data-name": "Path 3677",
    d: "M835.007,477.721l-40.654-33.263-156.459,235.3c-4.928,7.392-14.784,7.392-19.711,0C547.961,599.685,386.574,347.134,353.311,288L333.6,507.288c13.551,20.944,161.387,195.881,255.016,284.583,27.1,24.639,67.758,20.943,86.237-11.088Z",
    transform: "translate(409.83 210.347)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3678",
    "data-name": "Path 3678",
    d: "M319,347.2c2.464,1.232,4.928,1.232,6.16,2.464C320.232,348.432,319,347.2,319,347.2Z",
    transform: "translate(244.564 880.467)",
    fill: "#ffb288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3679",
    "data-name": "Path 3679",
    d: "M320.409,347.714c22.175-30.8,71.453-16.016,149.067,11.087,18.479,6.16,41.887,13.552,55.438,17.247,19.712,3.7,39.423,8.624,59.134,12.32h2.464c221.752,44.35,473.072,94.861,554.381,352.34,77.613,245.16,114.572,364.66,141.675,455.825,3.7,13.552,2.464,29.567-3.7,41.886-14.783,25.872-40.655,17.247-128.124,40.654-22.175,6.16-43.119-1.232-50.51-27.1-55.438-178.634-140.443-391.763-173.706-474.3-14.784-35.727-44.351-75.149-67.758-78.845L519.986,653.239C442.373,631.064,346.28,485.693,316.713,399.456,306.857,372.353,314.249,355.105,320.409,347.714Z",
    transform: "translate(164.31 691.463)",
    fill: "#452a51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3680",
    "data-name": "Path 3680",
    d: "M335.709,344.232c22.175-27.1,77.613-12.319,163.85,12.32,22.175,6.16,48.047,13.552,64.062,16.015,23.407,3.7,46.814,8.624,71.453,12.319,253.784,43.119,540.83,91.165,634.459,337.557L1318.811,851.8c64.062,168.778,93.629,248.856,118.268,319.077a52.137,52.137,0,0,1-45.583,68.99l-105.948,8.624a45.079,45.079,0,0,1-45.583-29.567c-55.438-157.691-131.82-336.325-193.417-461.985-17.248-36.959-60.366-71.453-92.4-76.382L561.157,627.583c-87.469-20.944-195.881-160.155-229.145-241.464C322.157,365.176,329.549,351.624,335.709,344.232Z",
    transform: "translate(337.499 682.625)",
    fill: "#452a51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3681",
    "data-name": "Path 3681",
    d: "M309.333,483.852c-40.655-82.541,30.8-171.242,121.964-188.489,113.34-20.944,149.067-30.8,234.072,14.783C744.214,352.032,791.029,439.5,779.941,497.4c-57.9,291.974,133.051,293.206,173.706,450.9,4.928,19.711,3.7,23.407-19.711,24.639C800.884,979.1,728.2,1037,534.781,1017.29c-16.015-1.232-33.263-1.232-49.278-9.855-12.32-6.16-29.567-30.8-40.655-48.046a76.638,76.638,0,0,1-11.088-32.031C407.889,706.836,359.843,587.336,309.333,483.852Z",
    transform: "translate(2.912 94.573)",
    fill: "#ffd878"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229",
    transform: "translate(212.456 430.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    "data-name": "Path 3682",
    d: "M828.866,863.079l19.711-43.119c-152.763-7.392-300.6-19.711-429.954-34.495-14.784-2.464-24.639-17.247-19.711-32.031C453.119,609.3,539.356,372.76,513.484,319.785c-6.16-13.552-39.423-49.278-78.845-33.263a22.843,22.843,0,0,1-8.624,2.464c-43.119,13.551-56.67,102.252-66.526,167.546-3.7,27.1-7.392,51.742-13.552,67.758C311.443,631.471,294.2,733.723,290.5,839.672c0,13.552,9.855,40.655,23.407,40.655,44.35,7.392,103.484-1.232,176.17-3.7C620.665,874.167,764.8,874.167,828.866,863.079Z",
    transform: "translate(-290.5 -282.471)",
    fill: "#ff9985"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3683",
    "data-name": "Path 3683",
    d: "M416.4,329.794c-1.232,1.232-3.7,1.232-3.7,0-1.232-9.856-1.232-16.015,0-20.943s-3.7-7.392-7.392-3.7c-7.392,7.392-13.552,17.247-18.479,27.1-7.392,17.247-1.232,13.551-14.784,40.654-7.391,14.784,11.088,24.639,24.639,25.871,25.871,1.232,76.382-23.407,88.7-46.814,6.16-12.32,2.464-25.871-2.464-40.655-2.464-8.624-12.319-13.552-17.247-16.015Z",
    transform: "translate(825.972 292.981)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230",
    transform: "translate(445.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3684",
    "data-name": "Path 3684",
    d: "M332.6,286.039a85.361,85.361,0,0,0,3.7-24.639Z",
    transform: "translate(-46.716 -90.754)",
    fill: "#895147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3685",
    "data-name": "Path 3685",
    d: "M380.918,488.416c-7.392-1.232-13.552-7.392-17.247-13.551,11.087-4.928,20.943-12.32,29.567-20.943,14.784-16.015,24.639-35.727,39.423-52.974,18.48-19.711,62.83-51.742,129.356-45.583,6.16,0,16.015,2.464,19.711-4.928,1.232-2.464,1.232-6.16,0-9.856,1.232,2.464,3.7,4.928,4.928,7.392-1.232-3.7-3.7-7.392-4.928-11.087a157,157,0,0,0-4.928-17.247,9.337,9.337,0,0,0-2.464-4.928c-1.232-1.232-2.464-2.464-3.7-2.464-2.464-1.232-4.927-2.464-7.392-2.464-28.335-34.495-68.99-57.9-113.34-61.6C369.83,240.793,307,298.695,309.464,377.54c1.232,39.423,18.479,75.149,44.35,103.484,1.232,4.928,1.232,11.087,2.464,16.015a105.085,105.085,0,0,0,16.015,43.119C372.294,538.926,380.918,488.416,380.918,488.416Z",
    transform: "translate(-309.394 -247.548)",
    fill: "#895147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3686",
    "data-name": "Path 3686",
    d: "M564.093,330.15c3.7-24.639-1.232-48.046-13.552-67.758A25.779,25.779,0,0,0,545.614,255c1.232,3.7,1.232,7.392,0,9.856-3.7,7.392-13.552,6.16-19.711,4.928-66.526-6.16-110.876,25.871-129.356,45.583-14.784,16.015-24.639,36.959-39.423,52.974-8.624,8.624-18.479,16.015-29.567,20.943,3.7,7.392,9.855,12.32,17.247,13.552l-8.624,50.51L312.773,596.253c-1.232,9.856,3.7,19.711,11.087,20.943l57.9,9.856c8.624,1.232,16.015-6.16,17.247-16.015l19.711-120.732c3.7,1.232,8.624,2.464,12.32,2.464,55.438,8.624,108.412-28.335,117.036-83.773l8.624-52.974,3.7-24.639Zm-30.8,29.567c1.232-6.16,4.928-11.087,8.624-9.855l12.319,2.464-7.391,4.928v4.928c-1.232,6.16-4.928,11.087-8.624,9.855S532.062,365.876,533.294,359.716Zm-50.51,38.191h0c2.464,2.464,4.928,4.928,8.624,3.7l11.087-1.232a13.369,13.369,0,0,0,9.856-9.855v2.464c1.232,7.392-3.7,16.015-9.856,16.015l-11.087,1.232C485.248,412.691,480.32,405.3,482.784,397.907Zm-23.407-55.438V347.4c-1.232,6.16-4.928,11.087-8.624,9.856s-6.16-6.16-4.928-12.32,4.928-11.087,8.624-9.856l12.32,2.464ZM485.248,432.4c1.232,0,1.232,1.232,1.232,2.464l-1.232,2.464c0,1.232-1.232,1.232-2.464,1.232l-19.711-7.392c-1.232,0-1.232-1.232-1.232-2.464l1.232-2.464c0-1.232,1.232-1.232,2.464-1.232ZM445.825,303.046l24.639,3.7A6.282,6.282,0,1,1,468,319.062l-24.639-3.7a6.282,6.282,0,1,1,2.464-12.319Zm112.108,30.8-18.479-2.464c-2.464,0-4.928-3.7-3.7-7.392,0-3.7,3.7-6.16,6.16-6.16l18.48,2.464c2.464,0,4.927,3.7,3.7,7.392S560.4,333.845,557.933,333.845Z",
    transform: "translate(-273.281 -163.199)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    "data-name": "Path 3687",
    d: "M328.022,271.22l24.639,3.7c3.7,0,7.392-2.464,7.392-4.928,0-3.7-2.464-7.392-4.928-7.392l-24.639-3.7c-3.7,0-7.392,2.464-7.392,4.928A5.428,5.428,0,0,0,328.022,271.22Z",
    transform: "translate(-157.942 -119.053)",
    fill: "#895147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    "data-name": "Path 3688",
    d: "M359.035,269.956c0-3.7-1.232-7.392-3.7-7.392L336.86,260.1c-2.464,0-4.927,2.464-6.16,6.16,0,3.7,1.232,7.392,3.7,7.392l18.479,2.464C355.339,276.116,357.8,273.652,359.035,269.956Z",
    transform: "translate(-68.223 -105.47)",
    fill: "#895147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3689",
    "data-name": "Path 3689",
    d: "M336.279,285.811l11.088-1.232c7.392-1.232,11.087-8.624,9.855-16.015V266.1a13.368,13.368,0,0,1-9.855,9.855l-11.088,1.232c-3.7,0-7.392-2.464-8.624-4.928v1.232C323.959,279.652,328.887,287.043,336.279,285.811Z",
    transform: "translate(-116.92 -37.552)",
    fill: "#fa694f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    d: "M323.594,271.53c-1.232,6.16,1.232,12.32,4.928,12.32,3.7,1.232,8.624-3.7,8.624-9.855v-4.928l7.392-4.928-12.32-2.464C329.754,260.443,324.826,265.37,323.594,271.53Z",
    transform: "translate(-152.282 -89.797)",
    fill: "#000543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3691",
    "data-name": "Path 3691",
    d: "M335.722,285.05c3.7,1.232,8.624-3.7,8.624-9.855v-4.928l7.391-4.928-12.319-2.464c-3.7-1.232-8.624,3.7-8.624,9.855C329.562,278.89,332.026,283.818,335.722,285.05Z",
    transform: "translate(-70.781 -76.213)",
    fill: "#000543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692",
    "data-name": "Path 3692",
    d: "M325.932,270.032,324.7,272.5c0,1.232,0,2.464,1.232,2.464l19.711,7.392c1.232,0,2.464,0,2.464-1.232l1.232-2.464c0-1.232,0-2.464-1.232-2.464L328.4,268.8C327.164,268.8,325.932,268.8,325.932,270.032Z",
    transform: "translate(-136.141 -6.989)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693",
    "data-name": "Path 3693",
    d: "M486.9,360.341C464.725,314.759,410.519,277.8,363.7,277.8c-45.583,0-65.294,36.959-43.119,82.541s76.382,82.541,123.2,82.541C489.364,442.883,509.076,405.924,486.9,360.341Z",
    transform: "translate(159.205 94.887)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694",
    "data-name": "Path 3694",
    d: "M381.384,373.016s-29.567-49.278,27.1-77.613c0,0,32.031-8.624,39.423,32.031C447.91,328.666,445.446,379.176,381.384,373.016Z",
    transform: "translate(863.453 285.485)",
    fill: "#ff9985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    "data-name": "Path 3695",
    d: "M469.836,424.853c12.319,0,23.407,0,35.727,2.464,20.944,4.928,36.959,22.175,56.67,28.335,29.567,11.088,64.062,1.232,93.629,11.088,41.886,13.552,62.83,59.134,76.382,101.021,16.015,52.974,25.871,109.644,51.742,158.923,14.784,28.335,33.263,54.206,44.351,83.773,11.087,32.031,9.856,67.758,19.711,101.021,11.087,38.19,28.335,76.381,57.9,103.484C888.7,978,886.238,933.652,877.615,894.23c-9.855-43.119-14.784-88.7-24.639-131.82-9.855-40.655-24.639-81.31-39.423-120.732-29.567-78.845-64.062-158.922-121.964-219.289a118.016,118.016,0,0,0-30.8-24.639c-12.32-6.16-25.871-7.392-38.191-9.855-93.629-13.552-187.258-24.639-280.887-34.495-4.928,0-12.319,27.1-11.088,32.031,4.928,8.624,35.727,14.783,44.351,18.479C404.542,415,436.573,423.621,469.836,424.853Z",
    transform: "translate(374.615 950.649)",
    fill: "#452a51"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231",
    transform: "translate(137.306 1023.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    "data-name": "Path 3696",
    d: "M1131.988,1379c-6.16,0-11.088-3.7-13.552-9.855L878.2,457.492C862.189,398.358,804.287,357.7,736.529,357.7H297.952a13.552,13.552,0,1,1,0-27.1H735.3c81.309,0,150.3,49.279,168.779,119.5l240.232,911.65c2.464,7.391-2.464,14.784-9.855,17.247Z",
    transform: "translate(-284.4 -330.6)",
    fill: "#6d72a0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    "data-name": "Path 3697",
    d: "M460.175,455.489c13.552,20.944,25.871,41.886,39.423,64.062a446.167,446.167,0,0,1,29.567,52.974c25.871,55.438,30.8,119.5,61.6,172.474,12.319,22.175,28.335,40.654,41.886,61.6a411.026,411.026,0,0,1,57.9,121.964C657.288,754.854,595.69,587.308,510.685,432.082c-12.319-22.175-27.1-45.583-51.742-51.742-17.247-4.928-39.423,0-50.511-13.552-2.464-3.7-4.928-7.392-8.624-9.855-6.16-3.7-16.016,0-19.712,7.391-14.783,24.639,18.48,24.639,34.495,34.495C434.3,413.6,447.855,435.777,460.175,455.489Z",
    transform: "translate(894.307 974.219)",
    fill: "#452a51"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232",
    transform: "translate(827.952 1087.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    "data-name": "Path 3698",
    d: "M955.692,1176.54H954.46c-1.232-1.232-2.464-3.7-1.232-4.928,6.16-11.088,7.392-25.871,3.7-39.423-27.1-89.933-64.062-209.433-141.675-454.592C742.563,448.452,533.13,385.622,343.408,343.736c-2.464,0-3.7-2.464-2.464-4.928,0-2.464,2.464-3.7,4.928-2.464,192.186,41.886,404.082,105.948,478,338.789,77.613,245.16,114.572,364.66,141.675,455.824,4.927,14.784,2.464,30.8-4.928,44.351A9.306,9.306,0,0,1,955.692,1176.54Z",
    transform: "translate(-340.461 -335.861)",
    fill: "#281930"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(428.049 567.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M766.288,360.231H324.015a16.015,16.015,0,1,1,0-32.031H766.288a16.015,16.015,0,0,1,0,32.031Z",
    transform: "translate(-308 98.058)",
    fill: "#132187"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233",
    transform: "translate(317.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M491.646,293.6h48.046c-23.407,0-46.814,17.247-52.974,39.423L383.234,711.234c-6.16,22.175,8.624,39.423,32.031,39.423H367.218c-23.407,0-38.191-17.247-32.031-39.423L438.672,333.023C443.6,312.079,468.238,293.6,491.646,293.6Z",
    transform: "translate(-333.786 -293.6)",
    fill: "#132187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    d: "M337.187,711.334,440.672,333.123c6.16-22.175,29.567-39.423,52.974-39.423h505.1c23.407,0,38.191,17.247,32.031,39.423L927.295,711.334c-6.16,22.175-29.567,39.423-52.974,39.423h-505.1C345.811,749.525,331.027,732.277,337.187,711.334Z",
    transform: "translate(-311.148 -292.468)",
    fill: "#000543"
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    "data-name": "Group 1242",
    transform: "translate(1671.363 3382.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237",
    transform: "translate(0 841.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    "data-name": "Path 3702",
    d: "M487.4,593.325H217.6a30.5,30.5,0,0,1-30.8-30.8V407.3a30.5,30.5,0,0,1,30.8-30.8H487.4a30.5,30.5,0,0,1,30.8,30.8V563.758C518.2,579.773,504.645,593.325,487.4,593.325ZM217.6,388.819a18.947,18.947,0,0,0-18.479,18.48V563.758A18.947,18.947,0,0,0,217.6,582.237H487.4a18.947,18.947,0,0,0,18.479-18.479V407.3a18.947,18.947,0,0,0-18.479-18.48Z",
    transform: "translate(-186.8 -376.5)",
    fill: "#bbcff2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238",
    transform: "translate(11.088 850.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3703",
    "data-name": "Path 3703",
    d: "M352.783,469.6,187.7,387.056l4.928-9.856,160.155,78.846L493.226,377.2l6.16,9.856Z",
    transform: "translate(-187.7 -377.2)",
    fill: "#bbcff2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239",
    transform: "translate(211.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3704",
    "data-name": "Path 3704",
    d: "M272.989,441.7,212.624,425.68c-4.928-1.232-7.392-4.928-8.624-9.856a12.937,12.937,0,0,1,6.16-11.087l192.186-96.093a9.581,9.581,0,0,1,9.856,2.464,9.477,9.477,0,0,1-1.232,12.32ZM382.634,333.283,216.319,417.056l54.206,12.32Z",
    transform: "translate(-204 -308.161)",
    fill: "#bbcff2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240",
    transform: "translate(273.495 3.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    d: "M238.567,504.947H236.1a13.37,13.37,0,0,1-9.856-9.855L209,429.8,346.979,310.3a9.239,9.239,0,0,1,11.087,0c3.7,2.464,3.7,7.392,1.232,11.088l-109.644,177.4A14.7,14.7,0,0,1,238.567,504.947Zm-16.015-71.453,14.783,57.9h1.232l98.557-157.691Z",
    transform: "translate(-209 -308.45)",
    fill: "#bbcff2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241",
    transform: "translate(147.352 120.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    d: "M204.172,1045.28c-2.464,0-3.7-1.232-4.928-3.7a5.924,5.924,0,0,1,2.464-7.391,203.612,203.612,0,0,0,27.1-16.016,6.16,6.16,0,0,1,7.392,9.856,203.442,203.442,0,0,1-27.1,16.015C206.636,1044.048,205.4,1045.28,204.172,1045.28Zm52.974-34.495a9.337,9.337,0,0,1-4.928-2.464c-2.464-2.464-1.232-6.16,1.232-8.624,8.624-6.16,16.015-13.552,23.407-19.711a6.1,6.1,0,1,1,8.624,8.624c-7.392,7.392-16.016,13.552-24.639,20.944C259.61,1009.553,258.378,1010.785,257.146,1010.785Zm46.815-43.118a4.525,4.525,0,0,1-3.7-1.232,5.954,5.954,0,0,1,0-8.624c7.392-7.392,13.552-16.016,19.711-23.407,2.464-2.464,6.16-3.7,8.624-1.232s3.7,6.16,1.232,8.624c-6.16,8.624-12.32,17.247-19.711,24.639C306.424,966.435,305.192,967.667,303.961,967.667Zm35.727-51.743c-1.232,0-2.464,0-2.464-1.232-2.464-1.232-3.7-4.928-2.464-8.624,4.928-8.624,9.856-18.479,12.32-28.335,1.232-2.464,4.928-4.928,7.392-3.7s4.928,4.928,3.7,7.392c-3.7,9.856-8.624,19.711-13.552,29.567C344.615,914.693,342.151,915.924,339.687,915.924Zm22.175-57.9h0c-4.928-1.232-6.16-3.7-6.16-7.392a124.111,124.111,0,0,0,3.7-30.8,6.16,6.16,0,0,1,12.32,0,142.036,142.036,0,0,1-3.7,32.031C366.79,855.558,364.326,858.022,361.863,858.022Zm2.464-62.83c-2.464,0-4.928-2.464-6.16-4.928-1.232-9.856-3.7-19.711-6.16-29.567-1.232-3.7,1.232-6.16,3.7-7.392,3.7-1.232,6.16,1.232,7.392,3.7,2.464,11.088,4.928,20.944,6.16,32.031,1.232,2.464-1.232,6.16-4.928,6.16Zm-16.015-60.366c-2.464,0-4.928-1.232-4.928-3.7-3.7-9.855-8.624-18.48-13.552-28.335a5.509,5.509,0,0,1,9.856-4.928c4.928,9.856,9.856,19.712,13.552,29.567,1.232,2.464,0,6.16-3.7,7.392C349.543,733.595,349.543,734.826,348.311,734.826Zm-29.567-55.438c-2.464,0-3.7-1.232-4.928-2.465a149.492,149.492,0,0,0-12.32-17.247c-2.464-2.464-3.7-6.16-6.16-8.624s-1.232-6.16,1.232-8.624,6.16-1.232,8.624,1.232,3.7,6.16,6.16,8.624c3.7,6.16,8.624,12.32,12.32,17.247a7.588,7.588,0,0,1-1.232,8.624C321.208,678.157,319.976,679.388,318.744,679.388Zm-34.495-52.975c-2.464,0-3.7-1.232-4.928-2.464-6.16-9.856-11.087-18.479-16.015-27.1a5.509,5.509,0,1,1,9.856-4.928c4.928,8.624,9.856,18.479,16.015,27.1a6.494,6.494,0,0,1-2.464,8.624A3.815,3.815,0,0,0,284.249,626.414Zm-29.567-55.438c-2.464,0-4.928-1.232-4.928-3.7a144.432,144.432,0,0,1-11.087-29.567c-1.232-3.7,1.232-6.16,3.7-7.392,3.7-1.232,6.16,1.232,7.392,3.7a113.012,113.012,0,0,0,11.087,28.335c1.232,2.464,0,6.16-3.7,7.392A3.817,3.817,0,0,1,254.682,570.976ZM236.2,510.61c-2.464,0-4.928-2.464-6.16-4.927-1.232-11.088-2.464-22.175-2.464-32.031a6.16,6.16,0,1,1,12.319,0c0,9.856,1.232,19.711,2.464,30.8,0,2.464-2.464,6.16-6.16,6.16Zm0-62.83h0c-3.7-1.232-6.16-3.7-6.16-7.392,2.464-11.087,4.928-20.943,9.856-30.8,1.232-2.464,4.928-4.928,7.392-3.7s4.928,4.928,3.7,7.392c-3.7,8.624-6.16,18.479-8.624,28.335C241.131,446.548,238.667,447.78,236.2,447.78Zm23.407-56.67a4.526,4.526,0,0,1-3.7-1.232c-2.464-1.232-3.7-4.928-1.232-8.624a201.024,201.024,0,0,1,20.943-24.639,6.1,6.1,0,0,1,8.624,8.624,180.111,180.111,0,0,0-19.711,23.407C263.306,389.878,262.074,391.11,259.61,391.11Zm44.351-45.582a9.34,9.34,0,0,1-4.928-2.464c-2.464-2.464-1.232-6.16,1.232-8.624,16.015-11.087,28.335-16.015,28.335-16.015,2.464-1.232,6.16,0,7.392,3.7,1.232,2.464,0,6.16-3.7,7.392A194.248,194.248,0,0,0,306.425,344.3C306.424,345.528,305.192,345.528,303.961,345.528Z",
    transform: "translate(-198.761 -317.962)",
    fill: "#bbcff2"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(1617.157 2605.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3707",
    "data-name": "Path 3707",
    d: "M272.333,359.672H204.575c-6.16,0-11.087-3.7-14.783-7.392a24.324,24.324,0,0,1-7.392-17.247V269.739A25.263,25.263,0,0,1,207.039,245.1h65.294a25.264,25.264,0,0,1,24.639,24.639v65.294a24.323,24.323,0,0,1-7.392,17.247C285.885,357.208,279.725,359.672,272.333,359.672Zm-66.526-6.16h66.526c4.928,0,9.856-2.464,13.552-4.928,3.7-3.7,6.16-8.624,6.16-13.552V269.739c0-4.928-2.464-9.856-4.928-13.552-3.7-3.7-8.624-6.16-13.552-6.16H208.271c-4.928,0-9.856,2.464-13.552,4.928-3.7,3.7-6.16,8.624-6.16,13.552V333.8c0,4.928,2.464,9.856,4.928,13.551,3.7,3.7,8.624,4.928,12.319,6.16Z",
    transform: "translate(-182.4 -245.1)",
    fill: "#fff"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245",
    transform: "translate(1619.621 2803.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3708",
    "data-name": "Path 3708",
    d: "M202.311,369.612c-4.928,0-9.856-2.464-13.552-6.16a22.73,22.73,0,0,1-6.16-14.784V282.143a20.4,20.4,0,0,1,6.16-14.784,22.731,22.731,0,0,1,14.784-6.16h66.526a20.4,20.4,0,0,1,14.783,6.16,22.73,22.73,0,0,1,6.16,14.784v66.526a20.4,20.4,0,0,1-6.16,14.784,22.731,22.731,0,0,1-14.783,6.16H202.311Z",
    transform: "translate(-182.6 -261.2)",
    fill: "#dcf1ff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1247",
    "data-name": "Group 1247",
    transform: "translate(1614.693 2994.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3709",
    "data-name": "Path 3709",
    d: "M274.6,392.5H203.143C190.824,391.272,182.2,381.416,182.2,369.1v-68.99A23.391,23.391,0,0,1,205.607,276.7H274.6c6.16,0,12.32,2.464,16.016,6.16,4.928,4.928,6.16,9.856,6.16,16.015v68.99C298,382.648,286.917,392.5,274.6,392.5Zm-70.221-6.16H274.6A16.842,16.842,0,0,0,291.844,369.1v-68.99c0-4.928-1.232-8.624-4.928-12.319s-7.392-4.928-12.32-4.928h-68.99a16.842,16.842,0,0,0-17.247,17.247V369.1c1.232,8.623,7.392,17.247,16.015,17.247Z",
    transform: "translate(-182.2 -276.7)",
    fill: "#fff"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248",
    transform: "translate(1617.157 3195.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3710",
    "data-name": "Path 3710",
    d: "M199.647,400.18c-4.928,0-8.624-2.464-12.319-4.928-3.7-3.7-4.928-8.624-4.928-13.551V311.479c0-11.087,8.624-18.479,19.711-18.479h70.222a18.143,18.143,0,0,1,18.479,18.479V381.7c0,11.087-8.624,18.479-19.711,18.479H199.647Z",
    transform: "translate(-182.4 -293)",
    fill: "#dcf1ff"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1251",
    "data-name": "Group 1251",
    transform: "translate(1762.528 2641.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3711",
    "data-name": "Path 3711",
    d: "M199.128,257.855a4.928,4.928,0,0,1,0-9.855l232.84,1.232a4.928,4.928,0,0,1,0,9.856l-232.84-1.232Z",
    transform: "translate(-194.2 -248)",
    fill: "#d7e1fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250",
    transform: "translate(1.232 27.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3712",
    "data-name": "Path 3712",
    d: "M199.228,260.055a4.928,4.928,0,1,1,0-9.855l343.716,1.232a4.928,4.928,0,0,1,0,9.855l-343.716-1.232Z",
    transform: "translate(-194.3 -250.2)",
    fill: "#d7e1fc"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    "data-name": "Group 1255",
    transform: "translate(1760.064 2839.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1252",
    "data-name": "Group 1252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3713",
    "data-name": "Path 3713",
    d: "M198.928,273.955a4.928,4.928,0,1,1,0-9.855l341.252,1.232a4.928,4.928,0,0,1,0,9.855l-341.252-1.232Z",
    transform: "translate(-194 -264.1)",
    fill: "#d7e1fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1253",
    "data-name": "Group 1253",
    transform: "translate(88.701 27.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3714",
    "data-name": "Path 3714",
    d: "M206.128,276.155a4.928,4.928,0,1,1,0-9.855h113.34a4.928,4.928,0,1,1,0,9.855Z",
    transform: "translate(-201.2 -266.3)",
    fill: "#d7e1fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1254",
    "data-name": "Group 1254",
    transform: "translate(0 27.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3715",
    "data-name": "Path 3715",
    d: "M198.928,276.155a4.928,4.928,0,1,1,0-9.855h67.758a4.928,4.928,0,1,1,0,9.855Z",
    transform: "translate(-194 -266.3)",
    fill: "#d7e1fc"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1258",
    "data-name": "Group 1258",
    transform: "translate(1762.528 3232.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3716",
    "data-name": "Path 3716",
    d: "M199.128,305.855a4.928,4.928,0,0,1,0-9.855l341.252,1.232a4.928,4.928,0,1,1,0,9.855l-341.252-1.232Z",
    transform: "translate(-194.2 -296)",
    fill: "#d7e1fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1257",
    "data-name": "Group 1257",
    transform: "translate(1.232 25.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3717",
    "data-name": "Path 3717",
    d: "M199.228,307.956a4.928,4.928,0,0,1,0-9.856h67.758a4.928,4.928,0,1,1,0,9.856Z",
    transform: "translate(-194.3 -298.1)",
    fill: "#d7e1fc"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263",
    transform: "translate(1762.528 3023.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    "data-name": "Group 1259",
    transform: "translate(0 28.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    "data-name": "Path 3718",
    d: "M199.128,291.155a4.928,4.928,0,0,1,0-9.855l341.252,1.232a4.928,4.928,0,0,1,0,9.855l-341.252-1.232Z",
    transform: "translate(-194.2 -281.3)",
    fill: "#d7e1fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    "data-name": "Group 1260",
    transform: "translate(89.933 56.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    d: "M206.428,293.455a4.928,4.928,0,1,1,0-9.855h113.34a4.928,4.928,0,0,1,0,9.855Z",
    transform: "translate(-201.5 -283.6)",
    fill: "#d7e1fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1261",
    "data-name": "Group 1261",
    transform: "translate(1.232 55.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    d: "M199.228,293.355a4.928,4.928,0,1,1,0-9.855h67.758a4.928,4.928,0,1,1,0,9.855Z",
    transform: "translate(-194.3 -283.5)",
    fill: "#d7e1fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1262",
    "data-name": "Group 1262",
    transform: "translate(1.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    "data-name": "Path 3721",
    d: "M199.228,288.855a4.928,4.928,0,1,1,0-9.855l341.253,1.232a4.928,4.928,0,0,1,0,9.856l-341.253-1.232Z",
    transform: "translate(-194.3 -279)",
    fill: "#d7e1fc"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264",
    transform: "translate(1638.051 2620.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M227.264,323.959a9.411,9.411,0,0,0,6.16-2.464l27.1-34.5c2.464-3.7,2.464-8.623-1.232-11.087s-8.624-2.464-11.088,1.232L228.5,301.784l-29.567-51.742a8.031,8.031,0,0,0-13.551,8.624L221.1,321.5c1.232,1.232,2.464,2.464,6.16,2.464Z",
    transform: "translate(-184.096 -246.296)",
    fill: "#ff5a8b"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265",
    transform: "translate(1638.051 2819.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    d: "M227.264,340.159a9.41,9.41,0,0,0,6.16-2.464l27.1-34.495c2.464-3.7,2.464-8.624-1.232-11.087s-8.624-2.464-11.088,1.232L228.5,317.984l-29.567-51.742a8.031,8.031,0,1,0-13.551,8.624L221.1,337.7c1.232,0,2.464,2.464,6.16,2.464Z",
    transform: "translate(-184.096 -262.496)",
    fill: "#ff5a8b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/aboutUs.434861ccd2d61d95dbc38e90d92d5a1b.svg";
export { ForwardRef as ReactComponent };